import React, { Component } from "react";
import "./../css/master.css";
import "./../css/maintainBuyersPo.css";
import Header from "./../js/header.js";
import axiosInstance from "../api/csAxios";
import $ from "jquery";
import DatePicker from "react-datepicker";
//import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactImageMagnify from "react-image-magnify";
const { IMG_TYPES } = require("./imgType");

var httpURL = "";
var queryString = require("querystring");
var lstCompany = [];
var lstSeason = [];
var lstFactory = [];
var lstDesignColor = [];
var lstCompanyPO = [];
var lstPoDesign = [];
var lstPOShowBuyers = [];
var lstBuyersForStatus = [];
var lstPoDetails = [];
var lstConstruction = [];
var lstYarnCount = [];
var lstWidth = [];
var lstQuality = [];
var lstSchedule = [];
var sortVal = "";
var COL_BPT_BPOID = "td:eq(0)";
var COL_BPT_BPOSTYLEID = "td:eq(1)";
var COL_BPT_BPONO = "td:eq(2)";
var COL_BPT_SEASON = "td:eq(3)";
var COL_BPT_DELIVERYDT = "td:eq(4)";
var COL_BPT_BPOQUALITY = "td:eq(5)";
var COL_BPT_STYLE = "td:eq(6)";
var COL_BPT_COLOR = "td:eq(7)";
var COL_BPT_QUALITYID = "td:eq(8)";
var COL_BPT_QUALITY = "td:eq(9)";
var COL_BPT_DESIGNCOLOR = "td:eq(10)";
var COL_BPT_LENGTH = "td:eq(11)";
var COL_BPT_WIDTHID = "td:eq(12)";
var COL_BPT_WIDTH = "td:eq(13)";
var COL_BPT_BUFFERDAYS = "td:eq(14)";
var COL_BPT_CONSTRUCTIONID = "td:eq(15)";
var COL_BPT_CONSTRUCTION = "td:eq(16)";
var COL_BPT_YARNCOUNTID = "td:eq(17)";
var COL_BPT_YARNCOUNT = "td:eq(18)";
var COL_BPT_STATUS = "td:eq(19)";
var COL_IPO_IPONO = "td:eq(22)";
var COL_IPO_IPOID = "td:eq(21)";
var COL_INTERNAL_IPODESIGNID = "td:eq(20)";

class MaintainBuyersPO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: [],
      season: [],
      factory: [],
      designNoColor: [],
      flg: true,
      flg1: true,
      flgStyle: true,
      companyPo: [],
      poDesign: [],
      poShowBuyers: [],
      buyersForStatus: [],
      poDetails: [],
      deliveryDate: null,
      startDate: null,
      endDate: null,
      minDate: new Date(),
      scheduleDate: null,
      loader: "none",
      opacity: 1,
      width: "97.6%",
      width1: "96%",
      flgAdd: true,
      quantityObj: {},
      onHoldState: true,
      src: require("./../images/blank.png"),
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.handleChange3 = this.handleChange3.bind(this);
  }

  handleChange(date) {
    this.setState({
      deliveryDate: date,
    });
  }

  handleChange1(date) {
    this.setState({
      startDate: date,
    });
  }

  handleChange2(date) {
    this.setState({
      endDate: date,
    });
  }
  handleChange3(date) {
    this.setState({
      scheduleDate: date,
    });
  }

  changeInpCompanyCmb = () => {
    $("#companyCmb").val($("#inp_companyCmb").find("option:selected").val());
    this.getCompanyPO();
    this.getBuyerForStatus();
  };

  addBuyerPO = () => {
    var companyId = $("#companyCmb").find("option:selected").val();
    if (companyId == 0 || companyId == undefined) {
      toast.warning("Please select company");
      return false;
    }
    $(".designPopup1").css("display", "block");
    $("#addPo")
      .show()
      .siblings(
        "#editPo,#editStyle,#addStyle,#deleteStyle,#viewProgress,#requestQuote,#changeQuantity"
      )
      .hide();
    $("#buyerPOAddForm").show().siblings().hide();
    this.getBuyerForStatus();
    $("#inp_companyCmb").val($("#companyCmb").find("option:selected").val());
    $("#inp_PONumber").val("");
    $("#seasonCmb").val(0);
    $("#factoryCmb").val(0);
    this.setState({ flg: true });
  };

  hideSlider(e) {
    e.preventDefault();
    $(".cd-panel").removeClass("is-visible");
    $(".designPopup1").hide();
    $(".designPopup1").css("width", "90%");
    $(".designPopup1").css("height", "90%");
    $(".designPopup1").css("left", "50%");
  }

  /*addPoDesignReady =()=>{
	  var poId = $('#buyerPOTableBody tr.selected').find(poIdCol).text();
	  if(poId == ''){
		  alert('Please select PO table');
		  return false;
	  }
	  $('#designColorCmb').val('0');
	  $('#inp_totalLength').val('');
	  $('#comment').val('');
	  $('#designImageDiv').empty();
	  this.setState({
		  flgPODesign : true
	  })
	}*/

  triggerUploadFile() {
    $("#uploadFile").trigger("click");
  }

  async componentDidMount() {
    localStorage.setItem("ipoDesignId", "");
    this.setState({ loader: "block", opacity: 0.5 });
    await axiosInstance
      .get(httpURL + "/a/mst/pco/list", {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          this.setState({
            company: response.data.lstParentComp,
          });
          lstCompany = this.state.company;
          this.fillCompanyCmb();
        } else {
          toast.error(response.data.SvcMsg);
          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.CSURL;
            return false;
          }
        }
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });

    axiosInstance
      .get(httpURL + "/a/mst/ssn/list", {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          this.setState({
            season: response.data.lstSeason,
          });
          lstSeason = this.state.season;
          this.fillSeasonCmb();
        } else {
          toast.error(response.data.SvcMsg);
        }
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
    axiosInstance
      .get(httpURL + "/a/mst/fac/list", {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          this.setState({
            factory: response.data.lstFactory,
          });
          lstFactory = this.state.factory;
          this.fillFactoryCmb();
        } else {
          toast.error(response.data.SvcMsg);
        }
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });

    axiosInstance
      .get(httpURL + "/a/mst/cons/list", {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          lstConstruction = response.data.lstConstruction;
          this.fillConstructionCmb();
        } else {
          toast.error(response.data.SvcMsg);
        }
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });

    axiosInstance
      .get(httpURL + "/a/mst/yarn/list", {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          lstYarnCount = response.data.lstYarnCount;
          this.fillYarnCountCmb();
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });

    axiosInstance
      .get(httpURL + "/a/mst/wdh/list", {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          lstWidth = response.data.lstWidth;
          this.fillWidthCmb();
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });

    axiosInstance
      .get(httpURL + "/a/mst/qlty/list", {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          lstQuality = response.data.lstQuality;
          this.fillQualityCmb();
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });

    this.handleResize();
    window.addEventListener("load", this.handleResize);
    window.addEventListener("resize", this.handleResize);

    var startDate = new Date();
    var startDate1 = startDate.setMonth(startDate.getMonth() - 4);
    this.setState({
      startDate: new Date(startDate1),
    });
    var endDate = startDate.setMonth(startDate.getMonth() + 5);
    this.setState({
      endDate: new Date(endDate),
    });
  }

  handleResize = () => {
    var width = $(".tableLayout1").parent().width() - 18;
    var width1 = $(".tableLayout2").parent().width() - 18;
    this.setState({ width: width, width1: width1 });
  };

  fillCompanyCmb() {
    $(".companyBox").empty();
    $(".companyBox").prepend($("<option> </option>").val(0).html("Company"));
    for (var i = 0; i < lstCompany.length; i++) {
      var companyId = lstCompany[i].parentCompId;
      var company = lstCompany[i].parentComp;
      $(".companyBox").append(
        $("<option> </option>").val(companyId).html(company)
      );
    }
  }

  fillSeasonCmb() {
    $("#seasonCmb").empty();
    $("#seasonCmb").prepend($("<option> </option>").val(0).html("Season"));
    for (var i = 0; i < lstSeason.length; i++) {
      var seasonId = lstSeason[i].seasonId;
      var season = lstSeason[i].season;
      $("#seasonCmb").append(
        $("<option> </option>").val(seasonId).html(season)
      );
    }
  }
  fillFactoryCmb() {
    $("#factoryCmb").empty();
    $("#factoryCmb").prepend($("<option> </option>").val(0).html("Factory"));
    for (var i = 0; i < lstFactory.length; i++) {
      var factoryId = lstFactory[i].factoryId;
      var factory = lstFactory[i].factoryName;
      $("#factoryCmb").append(
        $("<option> </option>").val(factoryId).html(factory)
      );
    }
  }

  fillConstructionCmb() {
    $("#input_construction").empty();
    $("#input_construction").prepend(
      $("<option> </option>").val(0).html("Construction")
    );
    for (var i = 0; i < lstConstruction.length; i++) {
      var constructionId = lstConstruction[i].constructionId;
      var construction = lstConstruction[i].construction;
      $("#input_construction").append(
        $("<option> </option>").val(constructionId).html(construction)
      );
    }
  }

  fillYarnCountCmb() {
    $("#input_yarnCount").empty();
    $("#input_yarnCount").prepend(
      $("<option> </option>").val(0).html("Yarn Count")
    );
    for (var i = 0; i < lstYarnCount.length; i++) {
      var yarnCountId = lstYarnCount[i].yarnCountId;
      var yarnCount = lstYarnCount[i].yarnCount;
      $("#input_yarnCount").append(
        $("<option> </option>").val(yarnCountId).html(yarnCount)
      );
    }
  }

  fillWidthCmb() {
    $("#input_width").empty();
    $("#input_width").prepend($("<option> </option>").val(0).html("Width"));
    for (var i = 0; i < lstWidth.length; i++) {
      var widthId = lstWidth[i].widthId;
      var width = lstWidth[i].width;
      $("#input_width").append(
        $("<option> </option>").val(widthId).html(width)
      );
    }
  }

  fillQualityCmb() {
    $("#input_qualityCmb").empty();
    $("#input_qualityCmb").prepend(
      $("<option> </option>").val(0).html("Quality Name")
    );
    for (var i = 0; i < lstQuality.length; i++) {
      var qualityId = lstQuality[i].qualityId;
      var quality = lstQuality[i].quality;
      $("#input_qualityCmb").append(
        $("<option> </option>").val(qualityId).html(quality)
      );
    }
  }

  getCompanyPO = () => {
    var companyId = $("#companyCmb").find("option:selected").val();
    var fromDt = $("#inp_fromDate").val();
    var toDt = $("#inp_toDate").val();

    if (companyId == 0 || companyId == undefined) {
      toast.warning("Please select company");
      return false;
    }
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .get(httpURL + "/a/bpo/list", {
        params: { parentCompId: companyId, fromDt: fromDt, toDt: toDt },
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          if (
            response.data.SvcMsg ==
            "No BuyerPO Exist for this Company. Add Some"
          ) {
            toast.success(response.data.SvcMsg);
            lstCompanyPO = [];
          } else {
            this.setState({
              companyPO: response.data.lstPO,
            });
            lstCompanyPO = this.state.companyPO;
          }
          this.setBuyerPOTable();
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };

  setBuyerPOTable = () => {
    $("#buyerPOTableBody tr").remove();
    var table = document.getElementById("buyerPOTable");
    var tbody = document.getElementById("buyerPOTableBody");
    var filterPoNo = $("#poNo").val().trim().toLowerCase();
    var filterStyle = $("#filterStyle").val().trim().toLowerCase();
    var filterDesignColor = $("#filterDesignColor").val().trim().toLowerCase();
    var filterIpoNo = $("#filterIpoNo").val().trim().toLowerCase();
    var filterOnHold = $("#filterOnHold").is(":checked");
    for (var i = 0; i < lstCompanyPO.length; i++) {
      var bpoId = lstCompanyPO[i].bpoId;
      var bpoNo = lstCompanyPO[i].bpoNo;
      var deliveryDt =
        lstCompanyPO[i].deliveryDt === null ? "-" : lstCompanyPO[i].deliveryDt;
      var buyerQuality = lstCompanyPO[i].buyerQuality;
      var bpoStyleId = lstCompanyPO[i].bpoStyleId;
      var style = lstCompanyPO[i].style;
      var color = lstCompanyPO[i].color;
      var qualityId = lstCompanyPO[i].qualityId;
      var quality = lstCompanyPO[i].quality;
      var designNoColor = lstCompanyPO[i].designNoColor;
      var length = lstCompanyPO[i].length;
      length = length == 0 ? "" : length;
      var widthId = lstCompanyPO[i].widthId;
      var width = lstCompanyPO[i].width;
      width = width == 0 ? "" : width;
      var season = lstCompanyPO[i].season;
      var factory = lstCompanyPO[i].factory;
      var bufferDays = lstCompanyPO[i].bufferDays;
      bufferDays = bufferDays == 0 ? "" : bufferDays;
      var constructionId = lstCompanyPO[i].constructionId;
      var construction = lstCompanyPO[i].construction;
      var yarnCountId = lstCompanyPO[i].yarnCountId;
      var yarnCount = lstCompanyPO[i].yarnCount;
      var ipoId = lstCompanyPO[i].ipoId;
      var ipoDesignId = lstCompanyPO[i].ipoDesignId;
      var ipoNo = lstCompanyPO[i].ipoNo;
      var onHold = lstCompanyPO[i].onHold ? "Yes" : "-";
      var status = "";

      var row = document.createElement("tr");
      row.id = "poTable" + bpoId;
      /*row.onclick =(e)=>{
				$(e.path[1]).addClass('selected').siblings().removeClass('selected');
				//this.getPoDesignDetails();
				$('#designColorCmb').val('0');
				$('#inp_totalLength').val('');
				$('#comment').val('');
				$('#designImageDiv').empty();
			}*/

      if (bpoNo.toLowerCase().indexOf(filterPoNo) === -1) continue;
      if (style.toLowerCase().indexOf(filterStyle) === -1) continue;
      if (designNoColor.toLowerCase().indexOf(filterDesignColor) === -1)
        continue;
      if (ipoNo.toLowerCase().indexOf(filterIpoNo) === -1) continue;
      if (filterOnHold && onHold !== "Yes") continue;
      this.addTD(row, bpoId, "no-display");
      this.addTD(row, bpoStyleId, "no-display");
      this.addTD(row, bpoNo, "");
      this.addTD(row, season, "");
      this.addTD(row, deliveryDt, "text-center");
      this.addTD(row, buyerQuality, "");
      this.addTD(row, style, "");
      this.addTD(row, color, "");
      this.addTD(row, qualityId, "no-display");
      this.addTD(row, quality, "");
      this.addTD(row, designNoColor, "");
      this.addTD(row, length, "text-right");
      this.addTD(row, widthId, "no-display");
      this.addTD(row, width, "no-display");
      this.addTD(row, bufferDays, "no-display");
      this.addTD(row, constructionId, "no-display");
      this.addTD(row, construction, "");
      this.addTD(row, yarnCountId, "no-display");
      this.addTD(row, yarnCount, "");
      this.addTD(row, status, "no-display");
      this.addTD(row, ipoId, "no-display");
      this.addTD(row, ipoDesignId, "no-display");
      this.addTDButton(row, ipoNo, "text-center");
      this.addTD(row, onHold, "text-center");
      this.addTDEdit(row, "glyphicon glyphicon-option-vertical", "text-center");
      this.addTDCbx(row, "text-center");

      tbody.append(row);
    }
    table.append(tbody);
  };

  getPoDesignDetails = () => {
    var poId = $("#buyerPOTableBody tr.selected").find(COL_BPT_BPOID).text();
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .get(httpURL + "/po/d/getpodesigndetails", {
        params: { poId: poId },
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          this.setState({
            poDesign: response.data.lstPODesignModel,
          });
          lstPoDesign = this.state.poDesign;
          this.fillPOForm();
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };

  fillPOForm = () => {
    var poId = lstPoDesign.poId;
    var poDesignId = lstPoDesign.poDesignId;
    var designNoColor = lstPoDesign.designNoColor;
    var style = lstPoDesign.style;
    var color = lstPoDesign.color;
    var expectedDt =
      lstPoDesign.expectedDt === null ? "-" : lstPoDesign.expectedDt;
    var deskloomDt =
      lstPoDesign.deskloomDt === null || lstPoDesign.deskloomDt === "00-00-00"
        ? "-"
        : lstPoDesign.deskloomDt;
    var yardageDt =
      lstPoDesign.yardageDt === null || lstPoDesign.yardageDt === "00-00-00"
        ? "-"
        : lstPoDesign.yardageDt;
    var totalMeters = lstPoDesign.totalMeters;
    var comments = lstPoDesign.comments;
    var imageName = lstPoDesign.imageName;
    var weaverId = lstPoDesign.weaverId;
    var weaver = lstPoDesign.weaver;
    var poCompletionData = lstPoDesign.poComplitionData;

    $("#inp_style").val(style);
    $("#inp_color").val(color);
    $("#designColorCmb").val(designNoColor);
    $("#inp_length").val(totalMeters);
    $("#inp_expectedDate").val(expectedDt);
    $("#inp_deskloomDate").val(deskloomDt);
    $("#inp_yardageDate").val(yardageDt);
    $("#inp_weaver").val(weaver);
    this.setDesignImage(poDesignId);
    this.setCompletionStatusTable(poCompletionData);
  };

  /*getPoShowBuyer =()=> {
	  var poId = $('#buyerPOTableBody tr.selected').find(poIdCol).text();
  	
	  axiosInstance.get(httpURL+'/a/p/lstposhowbuyers',{
		  params:{'poId':poId},
		  withCredentials: true
	  }).then((response)=> {
		  if(response.data.SvcStatus === 'Success'){
			  this.setState({
				  poShowBuyers:response.data.lstPOShowBuyers,
			  })
			  lstPOShowBuyers = this.state.poShowBuyers;
			  this.setHideStatusTable();
		  }
		  else{
			  alert(response.data.SvcMsg);
		  }
	  }).catch((error)=> {
		  alert("Service failed " + error);
	  });
	}
    
	setHideStatusTable =()=> {
	  $('#hideStatusBody tr').remove();
	  var table = document.getElementById('hideStatusTable');
	  var tbody = document.getElementById('hideStatusBody');
  	
	  for(var i=0; i<lstPOShowBuyers.length; i++){
		  var id 	 	= lstPOShowBuyers[i].buyerId;
		  var name 	= lstPOShowBuyers[i].buyerName;
		  var email 	= lstPOShowBuyers[i].buyerEmail;
		  var status 	= lstPOShowBuyers[i].hideStatus;
		  var row 	= document.createElement('tr');
	  	
		  this.addTD(row, id, 'no-display');
		  this.addTD(row, name, '');
		  this.addTD(row, email, '');
		  this.addTDCbxStatus(row, status, 'text-center');
	  	
		  tbody.append(row);
	  }
	  table.append(tbody);
	}*/

  addTD(row, val, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var text = document.createTextNode(val);
    cell.append(text);
    row.append(cell);
  }

  addTDButton(row, val, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var span = document.createElement("span");
    span.append(val);
    span.style.cursor = "pointer";
    span.style.width = "100%";
    span.title = "Click to open IPO Design";
    span.onclick = () => {
      $(row).addClass("selected").siblings().removeClass("selected");
      $("td").removeClass("selected");
      var ipoDesignId = $("#buyerPOTableBody tr.selected")
        .find("td:eq(21)")
        .text();
      localStorage.setItem("ipoDesignId", ipoDesignId);
      window.open("/cs/internalPO", "_blank");
    };
    cell.append(span);
    row.append(cell);
  }

  /*addTDClick(row, id, val, classname){
	  var cell = document.createElement('td');
	  cell.className = classname;
	  var text = document.createElement('span');
		  text.innerHTML = val;
	  text.style.textDecoration = 'underline';
	  text.style.cursor = 'pointer';
	  text.style.color = 'blue';
	  text.onclick =(e)=>{
		  e.stopPropagation();
		  $(e.path[2]).addClass('selected').siblings().removeClass('selected');
		  $('.cd-panel').addClass('is-visible');
		  $('#editPo').show().siblings('#viewProgress,#addPo,#addStyle,#editStyle').hide();
		  $('#buyerPOAddForm').show().siblings().hide();
		  $('#inp_company').val($('#companyCmb').find('option:selected').html());
		  this.getBuyerForAssignStatus();
		  this.setState({
			  flg : false,
		  })
	  };
	  cell.append(text);
	  row.append(cell);
	}*/

  addTDEdit(row, val, classname) {
    var cell = document.createElement("td");
    var span = document.createElement("span");
    cell.className = classname;
    span.className = val;
    span.style.position = "relative";
    span.style.cursor = "pointer";

    //alert(onHoldState)

    var ul = document.createElement("ul");
    ul.className = "ulStyle";
    var li1 = document.createElement("li");
    var li2 = document.createElement("li");
    var li3 = document.createElement("li");
    var li4 = document.createElement("li");
    // var li5 = document.createElement('li');
    var li6 = document.createElement("li");
    var li7 = document.createElement("li");
    var li8 = document.createElement("li");
    var li9 = document.createElement("li");

    li1.innerHTML = "Edit PO";
    li2.innerHTML = "Add Style";
    li3.innerHTML = "Edit Style";
    li4.innerHTML = "Delete Style";
    // li5.innerHTML = 'View Progress';
    li6.innerHTML = "Request Quote";
    li7.innerHTML = "Change Quantity";
    li8.innerHTML = "Return Stock";

    //{onHoldState === "-" ? li9.innerHTML = "Hold" : li9.innerHTML = "Unhold";}
    //li9.innerHTML = this.state.onHoldState === true ? "Hold" : "Unhold";

    li1.onclick = () => {
      $(".cd-panel").addClass("is-visible");
      $("#editPo")
        .show()
        .siblings(
          "#addPo,#editStyle,#addStyle,#deleteStyle,#viewProgress,#requestQuote,#changeQuantity"
        )
        .hide();
      $("#buyerPOAddForm").show().siblings().hide();
      var bpoId = $("#buyerPOTableBody tr.selected").find(COL_BPT_BPOID).text();
      var bpoStyleId = $("#buyerPOTableBody tr.selected")
        .find(COL_BPT_BPOSTYLEID)
        .text();
      this.fillBuyerPOForm(bpoId, bpoStyleId);
      this.getPoAssignedBuyers();
      this.setState({ flg: false });
      $(".designPopup1").css("display", "block");
    };

    li2.onclick = () => {
      this.setState({
        flgAdd: true,
      });
      $(".cd-panel").addClass("is-visible");
      $("#addStyle")
        .show()
        .siblings(
          "#addPo,#editPo,#editStyle,#deleteStyle,#viewProgress,#requestQuote,#changeQuantity"
        )
        .hide();
      $("#maintainStyleForm").show().siblings().hide();
      var bpoId = $("#buyerPOTableBody tr.selected").find(COL_BPT_BPOID).text();
      var bpoStyleId = $("#buyerPOTableBody tr.selected")
        .find(COL_BPT_BPOSTYLEID)
        .text();
      this.fillBuyerStyleForm(bpoId, bpoStyleId);
      $(".designPopup1").css("display", "block");
    };

    li3.onclick = () => {
      this.setState({
        flgAdd: false,
      });
      $(".cd-panel").addClass("is-visible");
      $("#editStyle")
        .show()
        .siblings(
          "#addPo,#editPo,#addStyle,#deleteStyle,#viewProgress,#requestQuote,#changeQuantity"
        )
        .hide();
      $("#maintainStyleForm").show().siblings().hide();
      var bpoId = $("#buyerPOTableBody tr.selected").find(COL_BPT_BPOID).text();
      var bpoStyleId = $("#buyerPOTableBody tr.selected")
        .find(COL_BPT_BPOSTYLEID)
        .text();
      this.fillBuyerStyleForm(bpoId, bpoStyleId);
      $(".designPopup1").css("display", "block");
    };

    li4.onclick = (e) => {
      var bpoId = $("#buyerPOTableBody tr.selected").find(COL_BPT_BPOID).text();
      var bpoStyleId = $("#buyerPOTableBody tr.selected")
        .find(COL_BPT_BPOSTYLEID)
        .text();
      var x = window.confirm("Are you sure you want to delete this style?");
      if (x) {
        this.setState({ loader: "block", opacity: 0.5 });
        axiosInstance
          .post(
            httpURL + "/a/bpo/deleteStyle",
            queryString.stringify({
              bpoId: parseInt(bpoId),
              bpoStyleId: parseInt(bpoStyleId),
            }),
            { withCredentials: true }
          )
          .then((response) => {
            if (response.data.SvcStatus === "Success") {
              toast.success(response.data.SvcMsg);
              var count = 0;
              $("#buyerPOTableBody tr").each(function () {
                var bId = $(this).find(COL_BPT_BPOID).text();
                if (bId == bpoId) {
                  count++;
                }
              });
              if (count > 1) {
                $(e.target).closest("tr").remove();
                var bpoIdx = this.getBuyerPOIdx(bpoId, bpoStyleId);
                lstCompanyPO.splice(bpoIdx, 1);
              } else {
                var bpoIdx = this.getBuyerPOIdx(bpoId, bpoStyleId);
                if (bpoIdx != -1) {
                  lstCompanyPO[bpoIdx].deliveryDt = "";
                  lstCompanyPO[bpoIdx].buyerQuality = "";
                  lstCompanyPO[bpoIdx].bpoStyleId = 0;
                  lstCompanyPO[bpoIdx].style = "";
                  lstCompanyPO[bpoIdx].color = "";
                  lstCompanyPO[bpoIdx].qualityId = 0;
                  lstCompanyPO[bpoIdx].quality = "";
                  lstCompanyPO[bpoIdx].bufferDays = 0;
                  lstCompanyPO[bpoIdx].designId = 0;
                  lstCompanyPO[bpoIdx].designNoColor = "";
                  lstCompanyPO[bpoIdx].length = 0;
                  lstCompanyPO[bpoIdx].constructionId = 0;
                  lstCompanyPO[bpoIdx].construction = "";
                  lstCompanyPO[bpoIdx].yarnCountId = 0;
                  lstCompanyPO[bpoIdx].yarnCount = "";
                  lstCompanyPO[bpoIdx].widthId = 0;
                  lstCompanyPO[bpoIdx].width = "";
                  this.setBuyerPOTable();
                }
              }
            } else {
              toast.error(response.data.SvcMsg);
            }
            this.setState({ loader: "none", opacity: 1 });
          })
          .catch((e) => {
            toast.error("Service failed " + e);
          });
      }
    };

    /* li5.onclick = () => {
			$('.cd-panel').addClass('is-visible');
			$('#viewProgress').show().siblings('#addPo,#editPo,#addStyle,#editStyle,#deleteStyle,#requestQuote,#changeQuantity').hide();
			$('#buyerProgressForm').show().siblings().hide();
			$('.designPopup1').css("display", "block");
		}; */

    li6.onclick = (e) => {
      var bpoDESIGNCOLOR = $("#buyerPOTableBody tr.selected")
        .find(COL_BPT_DESIGNCOLOR)
        .text();
      if (bpoDESIGNCOLOR !== "" && bpoDESIGNCOLOR !== null) {
        var bpoStyleId = $("#buyerPOTableBody tr.selected")
          .find(COL_BPT_BPOSTYLEID)
          .text();
        var x = this.getBuyerPOData2(bpoStyleId);
        if (x != -1) {
          var parentCompId = x.parentCompId;
          var parentComp = x.parentComp;
          var bpoId = x.bpoId;
          var buyerQuality = x.buyerQuality;
          var qualityId = x.qualityId;
          var constructionId = x.constructionId;
          var yarnCountId = x.yarnCountId;
          var widthId = x.widthId;
          var style = x.style;
          var length = x.length;
          var deliveryDt = x.deliveryDt;
          var color = x.color;
          var designId = x.designId;
          var designNoColor = x.designNoColor;
          var bpoNo = x.bpoNo;
          var bufferDays = x.bufferDays;
          var flag = "poScreen";
          this.props.history.push({
            pathname: "/cs/maintainQuotes",
            //search: '?style='+style+'&flag='+flag+'&bpoId='+bpoId+'&bpoNo='+bpoNo+'&color='+color+'&length='+length+'&deliveryDt='+deliveryDt+'&bpoStyleId='+bpoStyleId+'&designId='+designId+'&designNoColor='+designNoColor,
            search: "?flag=" + flag,
            state: {
              detail: {
                parentCompId: parentCompId,
                parentComp: parentComp,
                style: style,
                bpoId: bpoId,
                bpoNo: bpoNo,
                color: color,
                length: length,
                deliveryDt: deliveryDt,
                bpoStyleId: bpoStyleId,
                designId: designId,
                designNoColor: designNoColor,
                buyerQuality: buyerQuality,
                qualityId: qualityId,
                constructionId: constructionId,
                yarnCountId: yarnCountId,
                widthId: widthId,
                bufferDays: bufferDays,
              },
            },
          });
        }
      } else {
        toast.warning("Please set design color for this po first");
        return false;
      }
    };

    li7.onclick = () => {
      $("#new_IPOLength").attr("disabled", false);
      $("#new_BPOLength").val("");
      $("#new_IPOLength").val("");
      $(".cd-panel").addClass("is-visible");
      $("#changeQuantity")
        .show()
        .siblings(
          "#addPo,#editPo,#addStyle,#editStyle,#deleteStyle,#viewProgress,#requestQuote"
        )
        .hide();
      $("#changeQuantityForm").show().siblings().hide();
      $(".designPopup1").show();
      $(".designPopup1").addClass("quantityPopup");
      var bpoStyleId = $("#buyerPOTableBody tr.selected")
        .find(COL_BPT_BPOSTYLEID)
        .text();

      this.setState({ loader: "block", opacity: 0.5 });
      this.getScheduleList(bpoStyleId);

      axiosInstance
        .post(
          httpURL + "/a/bpo/getquantity",
          queryString.stringify({ bpoStyleId: parseInt(bpoStyleId) }),
          { withCredentials: true }
        )
        .then((response) => {
          if (response.data.SvcStatus === "Success") {
            this.setState({
              quantityObj: response.data.quantity,
            });
            $("#cur_BPOLength").val(this.state.quantityObj.bpoLength);
            $("#cur_IPOLength").val(
              this.state.quantityObj.ipoId == 0 ||
                this.state.quantityObj.ipoLength == 0
                ? ""
                : this.state.quantityObj.ipoLength
            );
            if (this.state.quantityObj.ipoId == 0)
              $("#new_IPOLength").attr("disabled", true);
          } else {
            toast.error(response.data.SvcMsg);
          }
        })
        .catch((e) => {
          toast.error("Service failed " + e);
        });
    };

    li8.onclick = () => {
      var ipoNo = $("#buyerPOTableBody tr.selected").find(COL_IPO_IPONO).text();
      var ipoId = $("#buyerPOTableBody tr.selected").find(COL_IPO_IPOID).text();
      var flag = "returnStock";

      if (ipoId !== "" || ipoId !== null) {
        var bpoStyleId = $("#buyerPOTableBody tr.selected")
          .find(COL_BPT_BPOSTYLEID)
          .text();
        var bpoNo = $("#buyerPOTableBody tr.selected")
          .find(COL_BPT_BPONO)
          .text();
        var x = this.getBuyerPOData2(bpoStyleId);
        console.log(x);
        if (x != -1) {
          var bpoId = x.bpoId;
          var bpoStyleId = x.bpoStyleId;
          var style = x.style;
          var color = x.color;
          var designId = x.designId;
          var designNoColor = x.designNoColor;
          var ipoDesignId = x.ipoDesignId;
          var quality = x.quality;
          var construction = x.construction;
          var width = x.width;
          var length = x.length;
          var yarnCount = x.yarnCount;
          var imageName = x.img;
          var imageUrl =
            window.httpURL +
            "/a/mst/dsn/getImage?img=" +
            imageName +
            "&imgType=" +
            IMG_TYPES.DSN;
          if (ipoDesignId === "" || ipoDesignId === null || ipoDesignId === 0) {
            toast.warning("You can not add stock for this design");
            return false;
          }

          var detail = {
            flag: flag,
            ipoDesignId: ipoDesignId,
            ipoId: ipoId,
            ipoNo: ipoNo,
            bpoId: bpoId,
            bpoNo: bpoNo,
            bpoStyleId: bpoStyleId,
            style: style,
            designId: designId,
            designNoColor: designNoColor,
            color: color,
            quality: quality,
            construction: construction,
            length: length,
            width: width,
            yarnCount: yarnCount,
            imageUrl: imageUrl,
          };
          localStorage.setItem("stock", JSON.stringify(detail));
          window.open("/cs/issueStock", "_blank");
        }
      }
    };

    li9.onclick = () => {
      var bpoId = $("#buyerPOTableBody tr.selected").find(COL_BPT_BPOID).text();
      var bpoStyleId = $("#buyerPOTableBody tr.selected")
        .find(COL_BPT_BPOSTYLEID)
        .text();
      var onHoldState = $("#buyerPOTableBody tr.selected")
        .find("td:eq(23)")
        .text();
      var onHold = "";
      //alert(bpoId , bpoStyleId, onHoldState);
      if (onHoldState === "Yes") {
        onHold = false;
      } else {
        onHold = true;
      }
      var holdStatus = { bpoId, bpoStyleId, onHold };
      this.setState({ loader: "block", opacity: 0.5 });
      axiosInstance
        .post(
          httpURL + "/a/bpo/toggleholdstyle",
          queryString.stringify({ holdStatus: JSON.stringify(holdStatus) }),
          { withCredentials: true }
        )
        .then((response) => {
          if (response.data.SvcStatus === "Success") {
            toast.success(response.data.SvcMsg);
            this.getCompanyPO();
          } else {
            toast.error(response.data.SvcMsg);
            this.setState({ loader: "none", opacity: 1 });
          }
          this.setState({ loader: "none", opacity: 1 });
        })
        .catch((e) => {
          toast.error("Service failed " + e);
          this.setState({ loader: "none", opacity: 1 });
        });
    };

    ul.append(li1);
    ul.append(li2);
    ul.append(li3);
    ul.append(li9);
    ul.append(li4);
    // ul.append(li5);
    ul.append(li6);
    ul.append(li7);
    ul.append(li8);

    span.onclick = (e) => {
      $(ul).toggle();
      $(e.target.closest("tr")).siblings().find("span ul").hide();
      $(e.target.closest("tr"))
        .addClass("selected")
        .siblings()
        .removeClass("selected");

      var onHoldState = $("#buyerPOTableBody tr.selected")
        .find("td:eq(23)")
        .text();
      if (onHoldState === "Yes") {
        li9.innerHTML = "Unhold";
      } else {
        li9.innerHTML = "Hold";
      }

      /*e.stopPropagation();
			$('.cd-panel').addClass('is-visible');
			if($(e.target).closest('tr').find(pobpoStyleIdCol).text() == ''){
				$('#editStyle').show().siblings('#addPo,#editPo,#viewProgress').hide();
				this.setState({flgStyle:true});
			}else{
				$('#editStyle').show().siblings('#addPo,#editPo,#viewProgress').hide();
				this.setState({flgStyle:false});
			}
			$('#addStyle,#editStyle').show().siblings('#addPo,#editPo,#viewProgress').hide();
			$('#maintainStyleForm').show().siblings().hide();
			//this.getPoShowBuyer();
			var date1 = new Date();
			this.setState({
				flg : true,
				minDate:date1,
				startDate : null,
			});*/
    };
    span.append(ul);
    cell.append(span);
    row.append(cell);
  }

  saveQuantity = () => {
    var bpoStyleId = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_BPOSTYLEID)
      .text();
    var oldBpoLength =
      $("#cur_BPOLength").val() == "" ? 0 : $("#cur_BPOLength").val();
    var bpoLength = $("#new_BPOLength").val();
    var oldIpoLength =
      $("#cur_IPOLength").val() == "" ? 0 : $("#cur_IPOLength").val();
    var ipoLength = $("#new_IPOLength").val();
    var ipoId = this.state.quantityObj.ipoId;
    var quanObj = {
      bpoLength: bpoLength == "" ? oldBpoLength : bpoLength,
      ipoLength: ipoLength == "" ? oldIpoLength : ipoLength,
      ipoId: ipoId,
    };
    var schedule = {};
    var lstScheduleArr = [];
    lstSchedule = [];

    var deliveryDt = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_DELIVERYDT)
      .text();
    $("#scheduleTableBody tr").each(function (index, value) {
      var scheduleId = $(this).find("td:eq(0)").text();
      var scheduleLength = $(this).find("td:eq(1)").text();
      var scheduleDt = $(this).find("td:eq(2)").text();
      var lstScheduleArr = {
        scheduleId: scheduleId,
        scheduleLength: scheduleLength,
        scheduleDt: scheduleDt,
      };
      lstSchedule.push(lstScheduleArr);
    });

    schedule = {
      bpoStyleId: bpoStyleId,
      deliveryDt: deliveryDt,
      lstSchedule: lstSchedule,
      quantity: quanObj,
    };

    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .post(
        httpURL + "/a/bpo/savequantityschedule",
        queryString.stringify({ schedule: JSON.stringify(schedule) }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
          $(".cd-panel").removeClass("is-visible");
          $(".designPopup1").hide();
          $(".designPopup1").css("width", "90%");
          $(".designPopup1").css("height", "90%");
          $(".designPopup1").css("left", "50%");
          this.getCompanyPO();
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((e) => {
        toast.error("Service failed " + e);
      });
  };

  addTDCbx(row, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var cbx = document.createElement("input");
    cbx.type = "checkbox";
    cbx.name = "object";
    cbx.onclick = (e) => {
      e.stopPropagation();
    };
    cell.append(cbx);
    row.append(cell);
  }

  addTDCbxStatus(row, status, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var cbx = document.createElement("input");
    cbx.type = "checkbox";
    if (status === true) {
      cbx.setAttribute("checked", "checked");
    }
    cell.append(cbx);
    row.append(cell);
  }

  addTDCbxStatus1(row, status, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var cbx = document.createElement("input");
    cbx.type = "checkbox";
    cbx.setAttribute("disabled", true);
    if (status === true) {
      cbx.setAttribute("checked", "checked");
    }
    cell.append(cbx);
    row.append(cell);
  }

  addTDImage(row, val, classname) {
    var date = new Date();
    var cell = document.createElement("td");
    cell.className = classname;
    var lazyload = document.createElement("LazyLoad");
    var img = document.createElement("img");
    img.style.width = "20px";
    img.style.height = "20px";
    if (val == "") {
      img.src = require("../images/logo.png");
    } else if (val != null) {
      img.src =
        window.httpURL +
        "/a/mst/dsn/getImage?img=" +
        val +
        "&imgType=" +
        IMG_TYPES.THUMB;
    } else {
      img.src = require("../images/logo.png");
    }
    lazyload.append(img);
    cell.append(lazyload);

    row.append(cell);
  }

  fillBuyerPOForm = (bpoId, bpoStyleId) => {
    var buyerPOData = this.getBuyerPOData(bpoId, bpoStyleId);
    if (buyerPOData != -1) {
      $("#inp_companyCmb").val(buyerPOData.parentCompId);
      $("#inp_poId").val(buyerPOData.bpoId);
      $("#inp_PONumber").val(buyerPOData.bpoNo);
      $("#seasonCmb").val(buyerPOData.seasonId);
      $("#factoryCmb").val(buyerPOData.factoryId);
    }
  };
  clearBuyerStyleForm = (bpoId) => {
    $("#input_poNumber").val(bpoId);
    $("#input_quality").val("");
    $("#input_style").val("");
    $("#input_color").val("");
    $("#input_price").val(0);
    $("#input_bufferDays").val("");
    $("#input_length").val("");
    $("#input_width").val(0);
    $("#input_yarnCount").val(0);
    $("#input_construction").val(0);
    $("#input_designId").val("");
    $("#input_designColor").val("");
    $("#input_deliveryDate").val("");
    $("#input_qualityCmb").val(0);
  };

  fillBuyerStyleForm = (bpoId, bpoStyleId) => {
    var buyerPOData = this.getBuyerPOData(bpoId, bpoStyleId);
    this.clearBuyerStyleForm(bpoId);

    if (buyerPOData != -1 && !this.state.flgAdd) {
      $("#input_poNumber").val(buyerPOData.bpoNo);
      //$('#input_deliveryDate').val(buyerPOData.deliveryDt == null ? '' : buyerPOData.deliveryDt);
      $("#input_quality").val(buyerPOData.buyerQuality);
      $("#input_style").val(buyerPOData.style);
      $("#input_color").val(buyerPOData.color);
      $("#input_price").val(buyerPOData.price);
      $("#input_bufferDays").val(
        buyerPOData.bufferDays == 0 ? 15 : buyerPOData.bufferDays
      );
      $("#input_length").val(buyerPOData.length == 0 ? "" : buyerPOData.length);
      $("#input_width").val(buyerPOData.widthId);
      $("#input_yarnCount").val(buyerPOData.yarnCountId);
      $("#input_construction").val(buyerPOData.constructionId);
      $("#input_designId").val(
        buyerPOData.designId == 0 ? "" : buyerPOData.designId
      );
      $("#input_designColor").val(buyerPOData.designNoColor);
      $("#input_qualityCmb").val(buyerPOData.qualityId);

      if (buyerPOData.deliveryDt == "") {
        var date1 = new Date();
        this.setState({
          minDate: date1,
          deliveryDate: null,
        });
      } else {
        var date = buyerPOData.deliveryDt;
        date = date.split("-");
        var selected = new Date(date[2], date[1] - 1, date[0]);
        var setDate = date.reverse().join();
        setDate = setDate.replace(/,/g, "-");
        var startDate = new Date(setDate);
        this.setState(
          {
            deliveryDate: startDate,
          },
          () => {
            var date1 = new Date();
            if (selected < date1) {
              this.setState({
                minDate: selected,
              });
            } else {
              this.setState({
                minDate: date1,
              });
            }
          }
        );
      }
    } else {
      $("#input_bufferDays").val(15);
      $("#input_poNumber").val(buyerPOData.bpoNo);
      var date1 = new Date();
      this.setState({
        minDate: date1,
        deliveryDate: null,
      });
    }

    if (
      buyerPOData.bpoStyleId == 0 ||
      buyerPOData.bpoStyleId == "" ||
      this.state.flgAdd
    ) {
      $("#maintainDesignBtn").attr("disabled", true);
      $("#divDesignColor input, #divDesignColor select").attr("disabled", true);
    } else {
      $("#maintainDesignBtn").attr("disabled", false);
      $("#divDesignColor input, #divDesignColor select").attr(
        "disabled",
        false
      );
    }
  };

  getBuyerPOData = (bpoId, bpoStyleId) => {
    for (var i = 0; i < lstCompanyPO.length; i++) {
      var obj = lstCompanyPO[i];
      if (obj.bpoId == bpoId && obj.bpoStyleId == bpoStyleId) {
        return lstCompanyPO[i];
      }
    }
    return -1;
  };
  getBuyerPOData2 = (bpoStyleId) => {
    for (var i = 0; i < lstCompanyPO.length; i++) {
      if (lstCompanyPO[i].bpoStyleId == bpoStyleId) {
        return lstCompanyPO[i];
      }
    }
    return -1;
  };

  /*completionStatesPopup=()=>{
		$('.completionStatesPopup').show();
		$('.main').addClass('addOpacity');
		this.viewCompletionStatus();
	}
    
	editHideStatus =()=>{
	  var lstBuyersHideStatus = [];
	  var poId 	= $('#buyerPOTableBody tr.selected').find(COL_BPT_BPOID).text();
  	
	  $('#hideStatusBody tr').each(function(){
		  if($(this).find('input[type="checkbox"]').prop('checked')){
			  var buyerId = $(this).find('td:eq(0)').text();
			  var hideStatus = 1;
		  }
		  else{
			  var buyerId = $(this).find('td:eq(0)').text();
			  var hideStatus = 0;
		  }
		  lstBuyersHideStatus.push({'buyerId':buyerId, 'hideStatus':hideStatus});
	  });
  	
	  axiosInstance.post(httpURL+'/a/p/editHideStatus', 
		  queryString.stringify({'poId' : poId, 'lstBuyersHideStatus'	: JSON.stringify(lstBuyersHideStatus)}), {withCredentials:true}
	  ).then((response)=>{	
		  if(response.data.SvcStatus === "Success"){
			  alert(response.data.SvcMsg);
			  $('.cd-panel').removeClass('is-visible');
		  }
		  else{
			  alert(response.data.SvcMsg);
		  }
	  }).catch((e)=>{
		  alert("Service failed "+e);
		  });
	}*/

  /*viewCompletionStatus =()=> {
	  var poDesignId = $('#poDesignTableBody tr.selected').find(poDesignIdCol).text();
  	
	  axiosInstance.get(httpURL+'/a/p/pocompletiondetails', {
		  params:{poDesignId:poDesignId},
		  withCredentials:true
	  }).then((response)=>{	
		  if(response.data.SvcStatus === "Success"){
			  this.setState({
				  poCompletionData:response.data.poCompletionData,
			  })
			  lstPoCompletionData = this.state.poCompletionData;
			  this.setCompletionStatusTable();
		  }
		  else{
			  alert(response.data.SvcMsg);
		  }
	  }).catch((e)=>{
		  alert("Service failed "+e);
		  });
	}*/

  setCompletionStatusTable = (lstPoCompletionData) => {
    $("#completionStatusTbody tr").remove();
    var table = document.getElementById("completionStatusTable");
    var tbody = document.getElementById("completionStatusTbody");

    for (var i = 0; i < lstPoCompletionData.length; i++) {
      var meters = lstPoCompletionData[i].meters;
      var date = lstPoCompletionData[i].dt;
      var invoiceNo = lstPoCompletionData[i].invoiceNo;

      var row = document.createElement("tr");

      this.addTD(row, meters, "text-right");
      this.addTD(row, date, "text-center");
      this.addTD(row, invoiceNo, "text-center");

      tbody.append(row);
    }
    table.append(tbody);
  };

  getBuyerForStatus = () => {
    lstBuyersForStatus = [];
    var companyId = $("#companyCmb").find("option:selected").val();
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .get(httpURL + "/a/bpo/pcoBuyers", {
        params: { parentCompId: companyId },
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          if (
            response.data.SvcMsg == "No Buyers Exist for this Company. Add Some"
          ) {
            toast.success("No Buyers Exist for this Company. Add Some");
            $("#buyerForStatusTbody tr").remove();
          } else {
            this.setState({
              buyersForStatus: response.data.lstBuyers,
            });
            lstBuyersForStatus = this.state.buyersForStatus;
            this.setBuyerForStatusTable();
          }
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((e) => {
        toast.error("Service failed " + e);
      });
  };

  getPoAssignedBuyers = () => {
    lstBuyersForStatus = [];
    var companyId = $("#companyCmb").find("option:selected").val();
    var bpoId = $("#buyerPOTableBody tr.selected").find(COL_BPT_BPOID).text();
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .get(httpURL + "/a/bpo/pcoBuyers", {
        params: { parentCompId: companyId, bpoId: bpoId },
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          if (
            response.data.SvcMsg == "No Buyers Exist for this Company. Add Some"
          ) {
            toast.success("No Buyers Exist for this Company. Add Some");
            $("#buyerForStatusTbody tr").remove();
          } else {
            this.setState({
              buyersForStatus: response.data.lstBuyers,
            });
            lstBuyersForStatus = this.state.buyersForStatus;
            this.setBuyerForStatusTable();
          }
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((e) => {
        toast.error("Service failed " + e);
      });
  };

  /*getBuyerForAssignStatus =()=>{
	  lstBuyersForStatus = [];
	  var poId = $('#buyerPOTableBody tr.selected').find(COL_BPT_BPOID).text();
  	
	  axiosInstance.get(httpURL+'/a/p/getpoassignedbuyers', {
		  params:{poId:poId},
		  withCredentials:true
	  }).then((response)=>{	
		  if(response.data.SvcStatus === "Success"){
			  this.setState({
				  poDetails:response.data.poDetails,
			  })
			  lstPoDetails = this.state.poDetails;
			  lstBuyersForStatus=lstPoDetails.buyerAssignedModel;
			  $('#inp_PONumber').val(lstPoDetails.poNo);
			  this.setBuyerForStatusTable();
			  var date = lstPoDetails.deliveryDt;
			  date = date.split('-');
			  var selected = new Date('20'+date[2], date[1]-1, date[0]);
			  var setDate = date.reverse().join();
				  setDate = setDate.replace(/,/g , '-');
				  setDate = '20'+setDate;
			  var startDate = new Date(setDate);
			  this.setState({
				  deliveryDate : startDate,
			  },()=>{
				  var date1 = new Date();
				  if(selected < date1){
					  this.setState({
						  minDate:selected,
					  })
				  }else{
					  this.setState({
						  minDate:date1,
					  })
				  }
			  })
		  	
			  $('#inp_deliveryDate').val(lstPoDetails.deliveryDt);
		  }
		  else{
			  alert(response.data.SvcMsg);
		  }
	  }).catch((e)=>{
		  alert("Service failed: "+e);
		  });
	}*/

  setBuyerForStatusTable = () => {
    $("#buyerForStatusTbody tr").remove();
    var table = document.getElementById("buyerForStatusTable");
    var tbody = document.getElementById("buyerForStatusTbody");

    for (var i = 0; i < lstBuyersForStatus.length; i++) {
      var buyerId = lstBuyersForStatus[i].buyerId;
      var buyer = lstBuyersForStatus[i].buyer;
      var type = lstBuyersForStatus[i].type;
      var eMail = lstBuyersForStatus[i].eMail;
      var phoneNo = lstBuyersForStatus[i].phoneNo;
      var selected = lstBuyersForStatus[i].selected;
      var row = document.createElement("tr");

      this.addTD(row, buyerId, "no-display");
      this.addTD(row, buyer, "");
      this.addTD(row, type, "");
      this.addTD(row, eMail, "");
      this.addTD(row, phoneNo, "");
      this.addTDCbxStatus(row, selected, "text-center");

      tbody.append(row);
    }
    table.append(tbody);
  };

  maintainPO = () => {
    if (this.state.flg) {
      this.addCompanyPO();
    } else {
      this.editCompanyPO();
    }
  };

  addCompanyPO() {
    var bpo = {};
    var buyerAssignedModel = [];
    var companyId = $("#inp_companyCmb").find("option:selected").val();
    var bpoNo = $("#inp_PONumber").val().toUpperCase();
    var seasonId = $("#seasonCmb").find("option:selected").val();
    var season = $("#seasonCmb").find("option:selected").text();
    var factoryId = $("#factoryCmb").find("option:selected").val();
    var factory = $("#factoryCmb").find("option:selected").text();
    if (companyId == 0) {
      toast.warning("Please select company");
      document.getElementById("inp_companyCmb").focus();
      return false;
    }

    if (bpoNo == "") {
      toast.warning("Please fill PO number");
      document.getElementById("inp_PONumber").focus();
      return false;
    }

    if (seasonId == 0) {
      toast.warning("Please select season");
      document.getElementById("seasonCmb").focus();
      return false;
    }

    $("#buyerForStatusTbody tr").each(function () {
      if ($(this).find('input[type="checkbox"]').prop("checked")) {
        var buyerId = $(this).find("td:eq(0)").text();
        buyerAssignedModel.push(buyerId);
      }
    });

    bpo.parentCompId = companyId;
    bpo.bpoId = 0;
    bpo.bpoNo = bpoNo;
    bpo.seasonId = seasonId;
    bpo.factoryId = factoryId;
    bpo.buyerAssignedModel = buyerAssignedModel;
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .post(
        httpURL + "/a/bpo/save",
        queryString.stringify({ bpo: JSON.stringify(bpo) }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
          delete bpo.buyerAssignedModel;
          bpo.bpoId = response.data.bpoId;
          bpo.bpoStyleId = 0;
          bpo.deliveryDt = "";
          bpo.buyerQuality = "";
          bpo.style = "";
          bpo.color = "";
          bpo.qualityId = 0;
          bpo.quality = "";
          bpo.designNoColor = "";
          bpo.length = "";
          bpo.widthId = 0;
          bpo.width = "";
          bpo.season = season;
          bpo.bufferDays = "";
          bpo.constructionId = 0;
          bpo.construction = "";
          bpo.yarnCountId = 0;
          bpo.yarnCount = "";
          bpo.ipoNo = "";

          lstCompanyPO.push(bpo);
          this.setBuyerPOTable();
          this.highlightRow(
            "buyerPOTableBody",
            response.data.bpoId,
            bpo.bpoStyleId
          );
          $(".cd-panel").removeClass("is-visible");
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((e) => {
        toast.error("Service failed " + e);
      });
  }

  editCompanyPO = () => {
    var bpo = {};
    var buyerAssignedModel = [];
    var bpoId = $("#inp_poId").val();
    var companyId = $("#inp_companyCmb").find("option:selected").val();
    var bpoNo = $("#inp_PONumber").val().toUpperCase();
    var seasonId = $("#seasonCmb").find("option:selected").val();
    var season = $("#seasonCmb").find("option:selected").text();
    var factoryId = $("#factoryCmb").find("option:selected").val();
    var factory = $("#factoryCmb").find("option:selected").text();
    var buyerQuality = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_QUALITY)
      .text();
    var bpoStyleId = parseInt(
      $("#buyerPOTableBody tr.selected").find(COL_BPT_BPOSTYLEID).text()
    );
    var style = $("#buyerPOTableBody tr.selected").find(COL_BPT_STYLE).text();
    var deliveryDt = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_DELIVERYDT)
      .text();
    var color = $("#buyerPOTableBody tr.selected").find(COL_BPT_COLOR).text();
    var qualityId = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_QUALITYID)
      .text();
    var quality = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_QUALITY)
      .text();
    var designNoColor = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_DESIGNCOLOR)
      .text();
    var length = $("#buyerPOTableBody tr.selected").find(COL_BPT_LENGTH).text();
    var widthId = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_WIDTHID)
      .text();
    var width = $("#buyerPOTableBody tr.selected").find(COL_BPT_WIDTH).text();
    var bufferDays = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_BUFFERDAYS)
      .text();
    var constructionId = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_CONSTRUCTIONID)
      .text();
    var construction = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_CONSTRUCTION)
      .text();
    var yarnCountId = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_YARNCOUNTID)
      .text();
    var yarnCount = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_YARNCOUNT)
      .text();

    if (bpoId == "") {
      toast.warning("Please select row");
      return false;
    }

    if (companyId == 0) {
      toast.warning("Please select company");
      document.getElementById("inp_companyCmb").focus();
      return false;
    }

    if (bpoNo == "") {
      toast.warning("Please fill PO number");
      document.getElementById("inp_PONumber").focus();
      return false;
    }

    if (seasonId == 0) {
      toast.warning("Please select season");
      document.getElementById("seasonCmb").focus();
      return false;
    }

    $("#buyerForStatusTbody tr").each(function () {
      if ($(this).find('input[type="checkbox"]').prop("checked")) {
        var buyerId = $(this).find("td:eq(0)").text();
        buyerAssignedModel.push(buyerId);
      }
    });

    bpo.parentCompId = companyId;
    bpo.bpoId = bpoId;
    bpo.bpoNo = bpoNo;
    bpo.seasonId = seasonId;
    bpo.factoryId = factoryId;
    bpo.buyerAssignedModel = buyerAssignedModel;
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .post(
        httpURL + "/a/bpo/save",
        queryString.stringify({ bpo: JSON.stringify(bpo) }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
          delete bpo.buyerAssignedModel;
          bpo.bpoStyleId = bpoStyleId;
          bpo.deliveryDt = deliveryDt;
          bpo.buyerQuality = buyerQuality;
          bpo.style = style;
          bpo.color = color;
          bpo.qualityId = qualityId;
          bpo.quality = quality;
          bpo.designNoColor = designNoColor;
          bpo.length = length;
          bpo.widthId = widthId;
          bpo.width = width;
          bpo.season = season;
          bpo.factory = factory;
          bpo.bufferDays = bufferDays;
          bpo.constructionId = constructionId;
          bpo.construction = construction;
          bpo.yarnCountId = yarnCountId;
          bpo.yarnCount = yarnCount;

          var poIdx = this.getBuyerPOIdx(bpoId, 0);
          if (poIdx == -1) {
            lstCompanyPO.push(bpo);
          } else {
            lstCompanyPO.splice(poIdx, 1, bpo);
          }
          this.setBuyerPOTable();
          this.highlightRow("buyerPOTableBody", bpoId, bpo.bpoStyleId);
          $(".cd-panel").removeClass("is-visible");
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((e) => {
        toast.error("Service failed " + e);
      });
  };

  getBuyerPOIdx(bpoId, pbpoStyleId) {
    for (var i = 0; i < lstCompanyPO.length; i++) {
      var obj = lstCompanyPO[i];
      if (obj.bpoId == bpoId) {
        if (pbpoStyleId != "" || pbpoStyleId != 0) {
          if (pbpoStyleId == obj.bpoStyleId) return i;
        } else return i;
      }
    }
    return -1;
  }

  highlightRow(table, id, pbpoStyleId) {
    $("#" + table + " tr").each(function () {
      var poId = $(this).find(COL_BPT_BPOID).text();
      var bpoStyleId = parseInt($(this).find(COL_BPT_BPOSTYLEID).text());
      if (poId == id && pbpoStyleId == bpoStyleId) {
        //if(pbpoStyleId != "" || pbpoStyleId != 0 || pbpoStyleId != NaN){
        //	if(pbpoStyleId == bpoStyleId)
        $(this).addClass("selected").siblings().removeClass("selected");
        //	return false;
        //}
      }
    });
  }

  selectAll(source) {
    var checkboxes = document.getElementsByName("object");
    for (var i = 0; i < checkboxes.length; i++) {
      if (i in checkboxes) {
        if (!checkboxes[i].disabled) {
          checkboxes[i].checked = source.target.checked;
        }
      }
    }
  }

  uploadPoStatus = () => {
    if (document.getElementById("uploadFile").value != "") {
      var ext = $("#uploadFile").val().split(".").pop().toLowerCase(); //input type file value

      if ($.inArray(ext, ["xls", "xlsx"]) === -1) {
        toast.warning("ext: " + ext);
        toast.warning("Invalid File Uploaded. Please, Upload Again!");
      } else {
        var file = document.getElementById("uploadFile"); //input type file value
        var file_data = file.files[0]; //No need Extra
        var file_data = $("#uploadFile").prop("files")[0]; //input type file value
        var form_data = new FormData();
        form_data.append("file", file_data);
        this.setState({ loader: "block", opacity: 0.5 });
        axiosInstance({
          url: httpURL + "/a/p/uploadpostatus",
          method: "POST",
          data: form_data,
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
          withCredentials: true,
        })
          .then((response) => {
            if (response.data.SvcStatus === "Success") {
              $("#uploadFile").val("");
              toast.success(response.data.SvcMsg);
              //var select = $('#buyerPOTableBody tr:first-child').attr('id');
              this.getPoDesignDetails();
              //document.getElementById(select).click();
            } else {
              toast.error(response.data.SvcMsg);
              $("#uploadFile").val("");
            }
            this.setState({ loader: "none", opacity: 1 });
          })
          .catch((e) => {
            toast.error("Service Failed: " + e);
          });
      }
    }
  };

  maintainStyle = () => {
    var companyId = $("#companyCmb").find("option:selected").val();
    var bpoId = $("#buyerPOTableBody tr.selected").find(COL_BPT_BPOID).text();
    var bpoStyleId = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_BPOSTYLEID)
      .text();
    bpoStyleId = this.state.flgAdd ? 0 : bpoStyleId;
    //var bpoNo 		= $('#input_poNumber').val();
    var deliveryDt = $("#input_deliveryDate").val();
    var buyerQuality = $("#input_quality").val();
    var style = $("#input_style").val();
    var color = $("#input_color").val();
    var bufferDays = $("#input_bufferDays").val();
    var price = $("#input_price").val();

    var poStyleModel = {};
    /*if(poNumber === ''){
			alert('Please fill PO number');
			document.getElementById('input_poNumber').focus();
			return false;
		}*/
    if (deliveryDt === "") {
      toast.warning("Please select delivery date");
      document.getElementById("input_deliveryDate").focus();
      return false;
    }

    if (style === "") {
      toast.warning("Please fill style");
      document.getElementById("input_style").focus();
      return false;
    }

    if (color === "") {
      toast.warning("Please fill color");
      document.getElementById("input_color").focus();
      return false;
    }

    if (bufferDays === "") {
      toast.warning("Please fill buffer days");
      document.getElementById("input_bufferDays").focus();
      return false;
    }
    if (price === "") {
      toast.warning("Please fill Price");
      document.getElementById("input_price").focus();
      return false;
    }

    if (buyerQuality === "") {
      toast.warning("Please fill quality");
      document.getElementById("input_quality").focus();
      return false;
    }

    poStyleModel.parentCompId = companyId;
    poStyleModel.bpoId = bpoId;
    poStyleModel.deliveryDt = deliveryDt;
    poStyleModel.bpoStyleId = bpoStyleId;
    poStyleModel.buyerQuality = buyerQuality;
    poStyleModel.style = style;
    poStyleModel.color = color;
    poStyleModel.bufferDays = bufferDays;
    poStyleModel.price = price;
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .post(
        httpURL + "/a/bpo/saveStyle",
        queryString.stringify({ poStyleModel: JSON.stringify(poStyleModel) }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
          if (bpoStyleId == 0) {
            bpoStyleId = response.data.bpoStyleId;
            this.getCompanyPO();
          } else {
            var poIdx = this.getBuyerPOIdx(bpoId, bpoStyleId);
            lstCompanyPO[poIdx].deliveryDt = deliveryDt;
            lstCompanyPO[poIdx].buyerQuality = buyerQuality;
            lstCompanyPO[poIdx].bpoStyleId = bpoStyleId;
            lstCompanyPO[poIdx].style = style;
            lstCompanyPO[poIdx].color = color;
            lstCompanyPO[poIdx].bufferDays = bufferDays;
            lstCompanyPO[poIdx].price = price;
            this.setBuyerPOTable();
          }

          setTimeout(
            function () {
              this.highlightRow("buyerPOTableBody", bpoId, bpoStyleId);
              $(".cd-panel").removeClass("is-visible");
            }.bind(this),
            1000
          );
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((e) => {
        toast.error("Service failed " + e);
      });
  };

  maintainDesign = () => {
    var poDesignModel = {};
    var bpoStyleId = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_BPOSTYLEID)
      .text();
    var bpoId = $("#buyerPOTableBody tr.selected").find(COL_BPT_BPOID).text();
    var length = $("#input_length").val();
    var widthId = $("#input_width").find("option:selected").val();
    var width =
      widthId == 0 ? "" : $("#input_width").find("option:selected").text();
    var yarnCountId = $("#input_yarnCount").find("option:selected").val();
    var yarnCount =
      yarnCountId == 0
        ? ""
        : $("#input_yarnCount").find("option:selected").text();
    var constructionId = $("#input_construction").find("option:selected").val();
    var construction =
      constructionId == 0
        ? ""
        : $("#input_construction").find("option:selected").text();
    var designId = $("#input_designId").val();
    var designNoColor = $("#input_designColor").val();
    var qualityId = $("#input_qualityCmb").find("option:selected").val();
    var quality =
      qualityId == 0
        ? ""
        : $("#input_qualityCmb").find("option:selected").text();

    if (length === "") {
      toast.warning("Please fill length");
      document.getElementById("input_length").focus();
      return false;
    }

    if (isNaN(length)) {
      toast.warning("Length should be numeric value");
      document.getElementById("input_length").focus();
      return false;
    }

    if (designId === "") {
      toast.warning("Please select design color");
      document.getElementById("input_designColor").focus();
      return false;
    }

    if (qualityId === "0") {
      toast.warning("Please select quality name");
      document.getElementById("input_qualityCmb").focus();
      return false;
    }

    poDesignModel.bpoStyleId = bpoStyleId;
    poDesignModel.length = length;
    poDesignModel.widthId = widthId;
    poDesignModel.yarnCountId = yarnCountId;
    poDesignModel.constructionId = constructionId;
    poDesignModel.designId = designId;
    poDesignModel.designNoColor = designNoColor;
    poDesignModel.qualityId = qualityId;
    poDesignModel.bpoId = bpoId;
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .post(
        httpURL + "/a/bpo/saveDesign",
        queryString.stringify({ poDesignModel: JSON.stringify(poDesignModel) }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
          var poIdx = this.getBuyerPOIdx(bpoId, bpoStyleId);
          lstCompanyPO[poIdx].length = length;
          lstCompanyPO[poIdx].widthId = widthId;
          lstCompanyPO[poIdx].width = width;
          lstCompanyPO[poIdx].yarnCountId = yarnCountId;
          lstCompanyPO[poIdx].yarnCount = yarnCount;
          lstCompanyPO[poIdx].constructionId = constructionId;
          lstCompanyPO[poIdx].construction = construction;
          lstCompanyPO[poIdx].designId = designId;
          lstCompanyPO[poIdx].designNoColor = designNoColor;
          lstCompanyPO[poIdx].qualityId = qualityId;
          lstCompanyPO[poIdx].quality = quality;
          this.setBuyerPOTable();
          this.highlightRow("buyerPOTableBody", bpoId, bpoStyleId);
          $(".cd-panel").removeClass("is-visible");
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((e) => {
        toast.error("Service failed " + e);
      });
  };

  setDesignImage(designId) {
    designId =
      typeof designId === "object" ? parseInt(designId.target.value) : designId;
    $("#designImageDiv").empty();
    var imageDiv = document.getElementById("designImageDiv");
    if (designId != "") {
      var imageName = this.getImageName(designId);
      var img = document.createElement("img");
      img.style.width = "100%";
      img.style.height = "100%";
      img.src =
        window.httpURL +
        "/a/mst/dsn/getImage?img=" +
        imageName +
        "&imgType=" +
        IMG_TYPES.DSN;
      imageDiv.append(img);
    }
  }

  getImageName(id) {
    for (var i = 0; i < lstDesignColor.length; i++) {
      if (lstDesignColor[i].designId === id) {
        return lstDesignColor[i].imageName;
      }
    }
    return "";
  }

  getDesignIdByName(name) {
    for (var i = 0; i < lstDesignColor.length; i++) {
      if (lstDesignColor[i].designNoColor == name) {
        return lstDesignColor[i].designId;
      }
    }
    return "";
  }

  sortAscByPo = () => {
    if (sortVal != "aspo") {
      sortVal = "aspo";
      $("#poAsDtIcon").css("color", "gray");
      $("#poDsDtIcon").css("color", "#111");
      $("#deliveryAsDtIcon").css("color", "#111");
      $("#deliveryDsDtIcon").css("color", "#111");

      var val1;
      var val2;

      for (var i = 0; i < lstCompanyPO.length - 1; i++) {
        val1 = lstCompanyPO[i].bpoNo;
        for (var j = i + 1; j < lstCompanyPO.length; j++) {
          val2 = lstCompanyPO[j].bpoNo;
          if (val1 > val2) {
            var tmp = lstCompanyPO[j];
            lstCompanyPO[j] = lstCompanyPO[i];
            lstCompanyPO[i] = tmp;
            val1 = lstCompanyPO[i].bpoNo;
          }
        }
      }
      this.setBuyerPOTable();
    }
  };

  sortDesByPo = () => {
    if (sortVal != "dspo") {
      sortVal = "dspo";
      $("#poAsDtIcon").css("color", "#111");
      $("#poDsDtIcon").css("color", "gray");
      $("#deliveryAsDtIcon").css("color", "#111");
      $("#deliveryDsDtIcon").css("color", "#111");

      var val1;
      var val2;

      for (var i = 0; i < lstCompanyPO.length - 1; i++) {
        val1 = lstCompanyPO[i].bpoNo;
        for (var j = i + 1; j < lstCompanyPO.length; j++) {
          val2 = lstCompanyPO[j].bpoNo;
          if (val1 < val2) {
            var tmp = lstCompanyPO[j];
            lstCompanyPO[j] = lstCompanyPO[i];
            lstCompanyPO[i] = tmp;
            val1 = lstCompanyPO[i].bpoNo;
          }
        }
      }
      this.setBuyerPOTable();
    }
  };

  sortAscByDelivery = () => {
    if (sortVal != "asdel") {
      sortVal = "asdel";
      $("#poAsDtIcon").css("color", "#111");
      $("#poDsDtIcon").css("color", "#111");
      $("#deliveryAsDtIcon").css("color", "gray");
      $("#deliveryDsDtIcon").css("color", "#111");

      var val1;
      var val2;
      var parts;
      var parts2;
      var dt1;
      var dt2;

      for (var i = 0; i < lstCompanyPO.length - 1; i++) {
        val1 = lstCompanyPO[i].deliveryDt;
        if (val1 != null) {
          parts = val1.split("-");
          dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
          for (var j = i + 1; j < lstCompanyPO.length; j++) {
            val2 = lstCompanyPO[j].deliveryDt;
            if (val2 != null) {
              parts2 = val2.split("-");
              dt2 = new Date(parts2[2], parts2[1] - 1, parts2[0]);

              if (dt1 > dt2) {
                var tmp = lstCompanyPO[j];
                lstCompanyPO[j] = lstCompanyPO[i];
                lstCompanyPO[i] = tmp;
                val1 = lstCompanyPO[i].deliveryDt;
                parts = val1.split("-");
                dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
              }
            }
          }
        }
      }
      this.setBuyerPOTable();
    }
  };

  sortDesByDelivery = () => {
    if (sortVal != "dsdel") {
      sortVal = "dsdel";
      $("#poAsDtIcon").css("color", "#111");
      $("#poDsDtIcon").css("color", "#111");
      $("#deliveryAsDtIcon").css("color", "#111");
      $("#deliveryDsDtIcon").css("color", "gray");

      var val1;
      var val2;
      var parts;
      var parts2;
      var dt1;
      var dt2;

      for (var i = 0; i < lstCompanyPO.length - 1; i++) {
        val1 = lstCompanyPO[i].deliveryDt;
        if (val1 != null) {
          parts = val1.split("-");
          dt1 = new Date(parts[2], parts[1] - 1, parts[0]);

          for (var j = i + 1; j < lstCompanyPO.length; j++) {
            val2 = lstCompanyPO[j].deliveryDt;
            if (val2 != null) {
              parts2 = val2.split("-");
              dt2 = new Date(parts2[2], parts2[1] - 1, parts2[0]);

              if (dt1 < dt2) {
                var tmp = lstCompanyPO[j];
                lstCompanyPO[j] = lstCompanyPO[i];
                lstCompanyPO[i] = tmp;
                val1 = lstCompanyPO[i].deliveryDt;
                parts = val1.split("-");
                dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
              }
            }
          }
        }
      }
      this.setBuyerPOTable();
    }
  };

  openDesignPopup = (e) => {
    if ($(e.target).prop("disabled") == true) {
      return false;
    } else {
      $(".designPopup").show();
      $(".main, .cd-panel").addClass("addOpacity");
      $("#machineTableBody tr").remove();
      this.setState({ loader: "block", opacity: 0.5 });
      axiosInstance
        .get(httpURL + "/a/mst/dsn/list", {
          withCredentials: true,
        })
        .then((response) => {
          if (response.data.SvcStatus === "Success") {
            this.setState({
              designNoColor: response.data.lstDesigns,
            });
            lstDesignColor = this.state.designNoColor;
            this.setDesignColorTable();
            var designId = $("#input_designId").val();
            if (designId != "") {
              $("#designColorTableBody tr").each(function () {
                if ($(this).attr("id") == designId) {
                  $(this).trigger("click");
                }
              });
            } else {
              this.setState({ src: require("./../images/blank.png") });
            }
          } else {
            toast.error(response.data.SvcMsg);
          }
          this.setState({ loader: "none", opacity: 1 });
        })
        .catch((error) => {
          toast.error("Service failed " + error);
        });
    }
  };

  setDesignColorTable = () => {
    $("#designColorTableBody tr").remove();
    var table = document.getElementById("designColorTable");
    var tbody = document.getElementById("designColorTableBody");
    var filterDesignColor = $("#designNoColor").val().toLowerCase();

    for (var i = 0; i < lstDesignColor.length; i++) {
      var id = lstDesignColor[i].designId;
      var designColor = lstDesignColor[i].designNoColor;
      var designImage = lstDesignColor[i].imgPath;
      var updatedOn = lstDesignColor[i].updatedOn;

      var row = document.createElement("tr");
      row.id = id;

      row.onclick = (e) => {
        $($(e.target).closest("tr"))
          .addClass("selected")
          .siblings()
          .removeClass("selected");
        this.setDesignColorForm(
          $("#designColorTableBody tr.selected").find("td:eq(0)").text()
        );
      };

      if (designColor.toLowerCase().indexOf(filterDesignColor) == -1) continue;

      this.addTD(row, id, "");
      this.addTD(row, designColor, "");
      this.addTDImage(row, designImage, "text-center");
      this.addTD(row, updatedOn, "");

      tbody.append(row);
    }
    table.append(tbody);
  };

  setDesignColorForm = (id) => {
    var date = new Date();
    var designColorData = this.getdesignColorData(id);
    $("#machineTableBody tr").find(
      $("input[type=checkbox]").attr("checked", false)
    );
    if (designColorData !== -1) {
      if (designColorData.imgPath == "") {
        this.setState({ src: require("./../images/blank.png") });
      } else if (designColorData.imgPath != null) {
        this.setState({
          src:
            window.httpURL +
            "/a/mst/dsn/getImage?img=" +
            designColorData.imgPath +
            "&imgType=" +
            IMG_TYPES.DSN,
        });
      } else {
        this.setState({ src: require("./../images/blank.png") });
      }
    }
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .get(httpURL + "/a/mst/dsn/listDesignMachineType", {
        params: {
          designId: id,
        },
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          var machineType = response.data.lstMachines;
          this.setMachineTable(machineType);
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };

  getdesignColorData(id) {
    for (var i = 0; i < lstDesignColor.length; i++) {
      if (id == lstDesignColor[i].designId) {
        return lstDesignColor[i];
      }
    }
    return -1;
  }

  setMachineTable = (lstMachine) => {
    $("#machineTableBody tr").remove();
    var table = document.getElementById("machineTable");
    var tbody = document.getElementById("machineTableBody");

    for (var i = 0; i < lstMachine.length; i++) {
      var machineTypeId = lstMachine[i].machineTypeId;
      var machineType = lstMachine[i].machineType;
      var capacity = lstMachine[i].capacity;
      var selected = lstMachine[i].selected;

      var row = document.createElement("tr");
      row.id = machineTypeId;

      this.addTD(row, machineTypeId, "no-display");
      this.addTD(row, machineType, "");
      this.addTD(row, capacity, "");
      this.addTDCbxStatus1(row, selected, "text-center");

      tbody.append(row);
    }
    table.append(tbody);
  };

  selectDesignColor = () => {
    this.setState({ loader: "none", opacity: 1 });
    $("#input_designId").val(
      $("#designColorTableBody tr.selected").find("td:eq(0)").text()
    );
    $("#input_designColor").val(
      $("#designColorTableBody tr.selected").find("td:eq(1)").text()
    );
    this.closePoPup();
  };

  closePoPup = (e) => {
    $(".designPopup").hide();
    $(".main, .cd-panel").removeClass("addOpacity");
  };

  addScheduleReady = () => {
    $("#scheduleAddForm").trigger("reset");
    $("body").addClass("showForm");
    this.setState({
      scheduleDate: null,
      flg1: true,
    });
  };

  maintainSchedule = () => {
    if (this.state.flg1) {
      this.addSchedule();
    } else {
      this.editSchedule();
    }
  };

  addSchedule = () => {
    var scheduleArr = {};
    var scheduleId = lstSchedule.length + 1;
    var scheduleLength = $("#scheduleLength").val();
    var scheduleDate = $("#scheduleDate").val();
    if (scheduleLength == "") {
      toast.warning("Please Enter Schedule Length");
      $("#scheduleLength").focus();
      return false;
    }
    if (scheduleDate == "") {
      toast.warning("Please Enter Schedule Date");
      $("#scheduleDate").focus();
      return false;
    }
    scheduleArr = {
      scheduleId: scheduleId,
      scheduleLength: scheduleLength,
      scheduleDt: scheduleDate,
    };
    lstSchedule.push(scheduleArr);
    $("#scheduleAddForm").trigger("reset");
    this.setState({
      scheduleDate: null,
      flg1: true,
    });
    this.setScheduleTable();
  };

  editSchedule = () => {
    var scheduleArr = {};
    var scheduleId = $("#scheduleTableBody tr.selected")
      .find("td:eq(0)")
      .text();
    var scheduleLength = $("#scheduleLength").val();
    var scheduleDate = $("#scheduleDate").val();
    if (scheduleLength == "") {
      toast.warning("Please Enter Schedule Length");
      $("#scheduleLength").focus();
      return false;
    }
    if (scheduleDate == "") {
      toast.warning("Please Enter Schedule Date");
      $("#scheduleDate").focus();
      return false;
    }
    scheduleArr = {
      scheduleId: scheduleId,
      scheduleLength: scheduleLength,
      scheduleDt: scheduleDate,
    };
    var scheduleIdx = this.getIdxSchedule(scheduleId);
    lstSchedule.splice(scheduleIdx, 1, scheduleArr);
    $("#scheduleAddForm").trigger("reset");
    this.setState({
      scheduleDate: null,
      flg1: true,
    });
    this.setScheduleTable();
  };

  getIdxSchedule(scheduleId) {
    for (var i = 0; i < lstSchedule.length; i++) {
      if (lstSchedule[i].scheduleId == scheduleId) {
        return i;
      }
    }
    return -1;
  }

  getScheduleList = (bpoStyleId) => {
    axiosInstance
      .post(
        httpURL + "/a/bpo/listschedule",
        queryString.stringify({ bpoStyleId: bpoStyleId }),
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          lstSchedule = response.data.schedule;
          this.setScheduleTable();
        } else {
          //toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };

  setScheduleTable = () => {
    $("#scheduleTableBody tr").remove();
    var table = document.getElementById("scheduleTable");
    var tbody = document.getElementById("scheduleTableBody");

    for (var i = 0; i < lstSchedule.length; i++) {
      var scheduleId = lstSchedule[i].scheduleId;
      var scheduleLength = lstSchedule[i].scheduleLength;
      var scheduleDt = lstSchedule[i].scheduleDt;

      var row = document.createElement("tr");
      row.id = scheduleId;

      this.addTD(row, scheduleId, "no-display");
      this.addTD(row, scheduleLength, "text-right");
      this.addTD(row, scheduleDt, "text-center");
      this.addTDDelete(row, "glyphicon glyphicon-trash", "text-center actions");

      tbody.append(row);
    }
    table.append(tbody);
  };

  addTDDelete(row, val, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var span = document.createElement("span");
    var span1 = document.createElement("span");
    span.className = val;
    span.style.cursor = "pointer";
    span.style.width = "100%";
    span.title = "Delete Schedule";
    span1.className = "glyphicon glyphicon-edit";
    span1.style.cursor = "pointer";
    span1.style.width = "100%";
    span1.title = "Edit Schedule";
    span.onclick = (e) => {
      $(row).addClass("selected").siblings().removeClass("selected");
      var scheduleId = $("#scheduleTableBody tr.selected")
        .find("td:eq(0)")
        .text();
      var tempList = lstSchedule;
      for (var i = 0; i < tempList.length; i++) {
        var obj = tempList[i];
        if (obj.scheduleId == scheduleId) {
          var index = tempList.indexOf(obj);
          tempList.splice(index, 1);
          lstSchedule = tempList;
          break;
        }
      }
      var temp = [];
      for (var i = 0; i < lstSchedule.length; i++) {
        var obj = lstSchedule[i];
        obj.scheduleId = i + 1;
        temp.push(obj);
      }
      lstSchedule = temp;
      this.setScheduleTable();
    };

    span1.onclick = (e) => {
      $("td").removeClass("selected");
      $(row).addClass("selected").siblings().removeClass("selected");
      $("body").addClass("showForm");
      var scheduleId = $("#scheduleTableBody tr.selected")
        .find("td:eq(0)")
        .text();
      this.setScheduleForm(scheduleId);
      this.setState({
        flg1: false,
      });
    };
    cell.append(span1);
    cell.append(span);
    row.append(cell);
  }

  setScheduleForm = (id) => {
    var scheduleData = this.getScheduleData(id);
    if (scheduleData !== -1) {
      $("#scheduleLength").val(scheduleData.scheduleLength);
      var date = scheduleData.scheduleDt;
      date = date.split("-");
      var setDate = date.reverse().join();
      setDate = setDate.replace(/,/g, "-");
      var scheduleDate = new Date(setDate);
      this.setState({
        scheduleDate: scheduleDate,
      });
    }
  };

  getScheduleData(id) {
    for (var i = 0; i < lstSchedule.length; i++) {
      if (id == lstSchedule[i].scheduleId) {
        return lstSchedule[i];
      }
    }
    return -1;
  }

  deleteSchedule = () => {
    var bpoStyleId = $("#buyerPOTableBody tr.selected")
      .find(COL_BPT_BPOSTYLEID)
      .text();
    axiosInstance
      .post(
        httpURL + "/a/bpo/deleteschedule",
        queryString.stringify({ bpoStyleId: bpoStyleId }),
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
          lstSchedule = [];
          this.setScheduleTable();
        } else {
          //toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };

  removeForm = () => {
    $("body").removeClass("showForm");
  };

  render() {
    httpURL = window.httpURL;
    return (
      <div style={{ height: "100%" }}>
        <Header />
        <ToastContainer autoClose={2000} hideProgressBar />
        <div
          style={{
            position: "fixed",
            width: 100,
            height: 100,
            marginLeft: -50,
            marginTop: -50,
            left: "50%",
            top: "50%",
            display: this.state.loader,
            zIndex: 9999,
          }}
        >
          <img src={require("../images/loader.gif")} alt="Loader..." />
        </div>
        <div className="main" style={{ opacity: this.state.opacity }}>
          <div className="container-fluid">
            <div className="col-sm-12 col-centered">
              <div style={{ marginBottom: 10 }}>
                <label htmlFor="companyCmb">Company</label>
                <select
                  style={{ marginLeft: 5 }}
                  className="select-box companyBox"
                  id="companyCmb"
                ></select>
                <label style={{ marginLeft: 10 }} htmlFor="inp_fromDate">
                  From Date
                </label>
                <div
                  style={{ display: "inline-block", marginLeft: 5, width: 100 }}
                >
                  <DatePicker
                    id="inp_fromDate"
                    className="form-control text-center"
                    placeholderText="From Date"
                    selected={this.state.startDate}
                    onChange={this.handleChange1}
                    dateFormat="dd-MM-yyyy"
                    autoComplete="off"
                  />
                </div>
                <label style={{ marginLeft: 10 }} htmlFor="inp_toDate">
                  To Date
                </label>
                <div
                  style={{ display: "inline-block", marginLeft: 5, width: 100 }}
                >
                  <DatePicker
                    id="inp_toDate"
                    className="form-control text-center"
                    placeholderText="To Date"
                    selected={this.state.endDate}
                    onChange={this.handleChange2}
                    dateFormat="dd-MM-yyyy"
                    autoComplete="off"
                  />
                </div>
                <button
                  style={{ marginLeft: 20 }}
                  type="button"
                  className="btn btn-warning"
                  onClick={this.getCompanyPO}
                  id="getBuyerPO"
                >
                  Get Buyer PO
                </button>
                <div className="pull-right">
                  <input
                    type="file"
                    onChange={this.uploadPoStatus}
                    id="uploadFile"
                    style={{ display: "none" }}
                  />
                  <button
                    style={{ marginRight: 20 }}
                    type="button"
                    onClick={this.addBuyerPO}
                    className="btn btn-warning"
                    id="addBuyerPO"
                  >
                    Add Buyer PO
                  </button>
                  <button
                    style={{ marginRight: 20 }}
                    type="button"
                    className="btn btn-warning"
                    onClick={this.triggerUploadFile}
                    id="uploadPOStatus"
                  >
                    Upload PO Status
                  </button>
                  <button
                    style={{ marginRight: 18 }}
                    type="button"
                    className="btn btn-warning"
                    id="sendMail"
                  >
                    Send Mail
                  </button>
                </div>
              </div>
              <div className="col-sm-12 padding-remove">
                <table
                  className="tableLayout1"
                  style={{ width: this.state.width }}
                >
                  <thead>
                    <tr>
                      <th style={{ width: 50, display: "none" }}>PO Id</th>
                      <th style={{ width: 50, display: "none" }}>Style Id</th>
                      <th style={{ width: 75 }}>
                        <div style={{ float: "left", width: "80%" }}>
                          <input
                            type="text"
                            onChange={this.setBuyerPOTable}
                            className="form-control inp-search"
                            id="poNo"
                            placeholder="PO No."
                          />
                        </div>
                        <div
                          style={{
                            width: 10,
                            float: "left",
                            marginLeft: 2,
                            marginTop: 4,
                          }}
                        >
                          <div className="assending">
                            <span
                              id="poAsDtIcon"
                              onClick={this.sortAscByPo}
                              className="glyphicon glyphicon-triangle-top"
                            ></span>
                          </div>
                          <div className="desending">
                            <span
                              id="poDsDtIcon"
                              onClick={this.sortDesByPo}
                              className="glyphicon glyphicon-triangle-bottom"
                            ></span>
                          </div>
                        </div>
                      </th>
                      <th style={{ width: 40 }}>Season</th>
                      <th style={{ width: 55, textAlign: "left" }}>
                        <div style={{ width: "90%", marginLeft: "5%" }}>
                          <div className="dateLabel">Delivery Date</div>
                          <div className="sortIcon">
                            <div className="assending">
                              <span
                                id="deliveryAsDtIcon"
                                onClick={this.sortAscByDelivery}
                                className="glyphicon glyphicon-triangle-top"
                              ></span>
                            </div>
                            <div className="desending">
                              <span
                                id="deliveryDsDtIcon"
                                onClick={this.sortDesByDelivery}
                                className="glyphicon glyphicon-triangle-bottom"
                              ></span>
                            </div>
                          </div>
                        </div>
                      </th>
                      <th style={{ width: 40 }}>Buyer Quality</th>
                      <th style={{ width: 60 }}>
                        <input
                          type="text"
                          onChange={this.setBuyerPOTable}
                          className="form-control inp-search"
                          id="filterStyle"
                          placeholder="Style"
                        />
                      </th>
                      <th style={{ width: 35 }}>Color</th>
                      <th style={{ width: 40 }}>Quality</th>
                      <th style={{ width: 40 }}>
                        <input
                          type="text"
                          onChange={this.setBuyerPOTable}
                          className="form-control inp-search"
                          id="filterDesignColor"
                          placeholder="Design Color"
                        />
                      </th>
                      <th style={{ width: 30 }}>Length</th>
                      <th style={{ width: 40, display: "none" }}>Width Id</th>
                      <th style={{ width: 30, display: "none" }}>Width</th>
                      <th style={{ width: 40, display: "none" }}>
                        Buffer Days
                      </th>
                      <th style={{ width: 40, display: "none" }}>
                        Construction Id
                      </th>
                      <th style={{ width: 40 }}>Construction</th>
                      <th style={{ width: 40, display: "none" }}>
                        Yarn Count Id
                      </th>
                      <th style={{ width: 40 }}>Yarn Count</th>
                      <th style={{ width: 40, display: "none" }}>Status</th>
                      <th style={{ width: 40, display: "none" }}>Ipo Id</th>
                      <th style={{ width: 40, display: "none" }}>
                        Ipo Design Id
                      </th>
                      <th style={{ width: 40 }}>
                        <input
                          type="text"
                          onChange={this.setBuyerPOTable}
                          className="form-control inp-search"
                          id="filterIpoNo"
                          placeholder="Ipo No."
                        />
                      </th>
                      <th style={{ width: 35 }}>
                        On Hold &nbsp;
                        <input
                          style={{ position: "absolute", top: 5 }}
                          type="checkbox"
                          id="filterOnHold"
                          onClick={this.setBuyerPOTable}
                        />
                      </th>
                      <th style={{ width: 25 }}>Action</th>
                      <th
                        style={{
                          width: 35,
                          position: "relative",
                          textAlign: "left",
                        }}
                      >
                        Select &nbsp;
                        <input
                          style={{ position: "absolute", top: 5 }}
                          type="checkbox"
                          id="selectAll"
                          onClick={this.selectAll}
                        />
                      </th>
                    </tr>
                  </thead>
                </table>
                <div className="col-sm-12 buyerPOTableDiv padding-remove">
                  <table id="buyerPOTable" className="tableLayout">
                    <colgroup>
                      <col width="75" />
                      <col width="40" />
                      <col width="55" />
                      <col width="40" />
                      <col width="60" />
                      <col width="35" />
                      <col width="40" />
                      <col width="40" />
                      <col width="30" />
                      <col width="40" />
                      <col width="40" />
                      <col width="40" />
                      <col width="35" />
                      <col width="25" />
                      <col width="35" />
                    </colgroup>
                    <tbody id="buyerPOTableBody"></tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="designPopup1">
          <header style={{ width: "65%" }}>
            <h3 id="addPo">Add PO</h3>
            <h3 id="editPo">Edit PO</h3>
            <h3 id="editStyle">Edit Style</h3>
            <h3 id="addStyle">Add Style</h3>
            <h3 id="deleteStyle">Delete Style</h3>
            <h3 id="viewProgress">View Progress</h3>
            <h3 id="requestQuote">Request Quote</h3>
            <h3 id="changeQuantity">Quantity/Schedule</h3>
            <a
              href="#0"
              className="cd-panel-close glyphicon glyphicon-remove"
              onClick={this.hideSlider}
            >
              Close
            </a>
          </header>

          <div style={{ width: "65%" }}>
            <div className="cd-panel-content">
              <div className="col-sm-12 col-centered">
                <form id="changeQuantityForm" className="form-horizontal">
                  <div className="form-group">
                    <label
                      className="control-label col-sm-3"
                      style={{ fontSize: 12, fontWeight: "bold" }}
                    >
                      BPO Length:<span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="col-sm-3">
                      <input
                        type="number"
                        className="form-control"
                        disabled
                        placeholder="BPO Length"
                        id="cur_BPOLength"
                      />
                    </div>
                    <label
                      className="control-label col-sm-3"
                      style={{ fontSize: 12, fontWeight: "bold" }}
                    >
                      IPO Length:<span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="col-sm-3">
                      <input
                        type="number"
                        className="form-control"
                        disabled
                        placeholder="IPO Length"
                        id="cur_IPOLength"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label
                      className="control-label col-sm-3"
                      style={{ fontSize: 12 }}
                    >
                      New BPO Length:<span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="col-sm-3">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="New Length"
                        id="new_BPOLength"
                      />
                    </div>
                    <label
                      className="control-label col-sm-3"
                      style={{ fontSize: 12 }}
                    >
                      New IPO Length:<span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="col-sm-3">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="New Length"
                        id="new_IPOLength"
                      />
                    </div>
                  </div>

                  <div className="col-sm-12 col-centered scheduleStyle">
                    <div className="col-md-7  col-xs-7 scheduleWrap  padding-remove">
                      <table className="tableLayout1 schedule">
                        <thead>
                          <tr>
                            <th style={{ display: "none" }}> Schedule Id </th>
                            <th style={{ width: 40 }}> Length </th>
                            <th style={{ width: 40 }}> Schedule Date </th>
                            <th style={{ width: 30 }}> Delete </th>
                          </tr>
                        </thead>
                      </table>
                      <div
                        className="scheduleTableDiv"
                        style={{
                          height: "150px",
                          overflowY: "scroll",
                          border: "1px solid #ccc",
                        }}
                      >
                        <table id="scheduleTable" className="tableLayout">
                          <colgroup>
                            <col width="40" />
                            <col width="40" />
                            <col width="30" />
                          </colgroup>
                          <tbody id="scheduleTableBody"></tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-xs-1 ">
                      <span
                        id="addSchedule"
                        title="Add Schedule"
                        onClick={this.addScheduleReady}
                        className="addIcon glyphicon glyphicon-plus-sign"
                      ></span>
                    </div>
                    <div className="col-md-5 col-xs-8 padding-remove scheduleFormWrap">
                      <form
                        id="scheduleAddForm"
                        className="form-horizontal formWrapper"
                      >
                        <div className="form-group">
                          <label className="control-label col-sm-5">
                            Length
                            <span style={{ color: "red", marginLeft: 2 }}>
                              *
                            </span>
                          </label>
                          <div className="col-sm-6 padding-remove">
                            <input
                              autoComplete="off"
                              id="scheduleLength"
                              type="text"
                              className="form-control "
                              placeholder="Enter Length"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="control-label col-sm-5">
                            Schedule Date<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="col-sm-6 padding-remove">
                            <DatePicker
                              id="scheduleDate"
                              className="form-control"
                              placeholderText="Schedule Date"
                              selected={this.state.scheduleDate}
                              onChange={this.handleChange3}
                              dateFormat="dd-MM-yyyy"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="col-sm-12 text-right buttonWrap">
                            <button
                              type="button"
                              style={{ marginTop: 20 }}
                              title="Schedule"
                              onClick={this.maintainSchedule}
                              className="btn btn-warning"
                            >
                              Add Schedule
                            </button>
                            <button
                              type="button"
                              style={{ marginTop: 20 }}
                              title="Cancel"
                              onClick={this.removeForm}
                              className="btn btn-warning"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-4 col-centered text-center qualityButtons">
                      <button
                        type="button"
                        onClick={this.saveQuantity}
                        className="btn btn-warning saveQuality"
                      >
                        Save
                      </button>
                      <button
                        type="button"
                        onClick={this.deleteSchedule}
                        className="btn btn-danger saveQuality"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </form>
                <form id="buyerPOAddForm" className="form-horizontal">
                  <div className="form-group">
                    <label className="control-label col-sm-3">
                      Company:<span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="col-sm-9">
                      <select
                        style={{ width: "100%" }}
                        className="select-box companyBox"
                        onChange={this.changeInpCompanyCmb}
                        id="inp_companyCmb"
                      ></select>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="control-label col-sm-3">
                      PO Number:<span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="PO Number"
                        style={{ display: "none" }}
                        id="inp_poId"
                      />
                      <input
                        type="text"
                        maxLength="50"
                        className="form-control"
                        placeholder="PO Number"
                        id="inp_PONumber"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="control-label col-sm-3">
                      Season:<span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="col-sm-9">
                      <select
                        style={{ width: "100%" }}
                        className="select-box"
                        id="seasonCmb"
                      >
                        <option>Season</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="control-label col-sm-3">Factory:</label>
                    <div className="col-sm-9">
                      <select
                        style={{ width: "100%" }}
                        className="select-box"
                        id="factoryCmb"
                      >
                        <option>Factory</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group" style={{ marginBottom: 2 }}>
                    <label className="control-label col-sm-3">
                      Buyers for Status:
                    </label>
                    <div className="col-sm-9"></div>
                  </div>
                  <div
                    className="col-sm-12 padding-remove"
                    style={{
                      height: 150,
                      paddingRight: 0,
                      overflowY: "scroll",
                      marginBottom: 50,
                    }}
                  >
                    <table id="buyerForStatusTable" className="tableLayout">
                      <thead>
                        <tr>
                          <th width="60">Name</th>
                          <th width="50">Type</th>
                          <th width="140">E-Mail</th>
                          <th width="60">Phone</th>
                          <th width="40">Select</th>
                        </tr>
                      </thead>
                      <tbody id="buyerForStatusTbody"></tbody>
                    </table>
                  </div>
                  <div className="form-group">
                    <div className="col-sm-12 text-center">
                      <button
                        type="button"
                        onClick={this.maintainPO}
                        className="btn btn-warning"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
                <form id="buyerProgressForm" className="form-horizontal">
                  <div className="row">
                    <div className="form-group col-sm-6">
                      <label className="control-label col-sm-6">Style:</label>
                      <div className="col-sm-6 padding-remove">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Style"
                          id="inp_style"
                        />
                      </div>
                    </div>
                    <div className="form-group col-sm-6">
                      <label className="control-label col-sm-6">Color:</label>
                      <div className="col-sm-6 padding-remove">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Color"
                          id="inp_color"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-sm-6">
                      <label className="control-label col-sm-6">
                        Design-Color:
                      </label>
                      <div className="col-sm-6 padding-remove">
                        <select
                          style={{ width: "100%" }}
                          className="select-box"
                          id="designColorCmb"
                          onChange={this.setDesignImage.bind(this)}
                        >
                          <option>Select</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group col-sm-6">
                      <label className="control-label col-sm-6">Length:</label>
                      <div className="col-sm-6 padding-remove">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Length"
                          id="inp_length"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-sm-6">
                      <label className="control-label col-sm-6">
                        Expected Date:
                      </label>
                      <div className="col-sm-6 padding-remove">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Expected Date"
                          id="inp_expectedDate"
                        />
                      </div>
                    </div>
                    <div className="form-group col-sm-6">
                      <label className="control-label col-sm-6">
                        Deskloom Date:
                      </label>
                      <div className="col-sm-6 padding-remove">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Deskloom Date"
                          id="inp_deskloomDate"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-sm-6">
                      <label className="control-label col-sm-6">
                        Yardage Date:
                      </label>
                      <div className="col-sm-6 padding-remove">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Yardage Date"
                          id="inp_yardageDate"
                        />
                      </div>
                    </div>
                    <div className="form-group col-sm-6">
                      <label className="control-label col-sm-6">Weaver:</label>
                      <div className="col-sm-6 padding-remove">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Weaver"
                          id="inp_weaver"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: 20 }}>
                    <div
                      className="col-sm-9"
                      style={{
                        paddingRight: 0,
                        height: 250,
                        overflowY: "scroll",
                      }}
                    >
                      <table id="completionStatusTable" className="tableLayout">
                        <thead>
                          <tr>
                            <th style={{ width: "33%" }}>Meters</th>
                            <th style={{ width: "33%" }}>Date</th>
                            <th style={{ width: "33%" }}>Invoice No.</th>
                          </tr>
                        </thead>
                        <tbody id="completionStatusTbody"></tbody>
                      </table>
                    </div>
                    <div className="col-sm-3">
                      <div id="designImageDiv"></div>
                    </div>
                  </div>
                </form>
                <form id="maintainStyleForm" className="form-horizontal">
                  <label style={{ fontSize: 18 }}>Buyer Style Info</label>
                  <div
                    style={{
                      background: "#f7f3f3",
                      paddingTop: 10,
                      borderRadius: 6,
                    }}
                  >
                    <div className="row">
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">
                          Buyer PO:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                          <input
                            type="text"
                            className="form-control"
                            readOnly
                            placeholder="Buyer PO"
                            id="input_poNumber"
                          />
                        </div>
                      </div>
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">
                          Delivery Date:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                          <DatePicker
                            id="input_deliveryDate"
                            className="form-control"
                            placeholderText="Delivery Date"
                            selected={this.state.deliveryDate}
                            onChange={this.handleChange}
                            dateFormat="dd-MM-yyyy"
                            minDate={this.state.minDate}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">
                          Style:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Style"
                            id="input_style"
                          />
                        </div>
                      </div>
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">
                          Color:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Color"
                            id="input_color"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">
                          Buffer Days:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Buffer Days"
                            id="input_bufferDays"
                          />
                        </div>
                      </div>
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">
                          Quality Name:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Quality Name"
                            id="input_quality"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: 10 }}>
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">
                          Price:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Price"
                            id="input_price"
                          />
                        </div>
                      </div>
                      <div className="form-group col-sm-6 padding-remove text-right">
                        <button
                          type="button"
                          onClick={this.maintainStyle}
                          className="btn btn-warning"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <label style={{ fontSize: 18 }}>Design Info</label>
                  <div
                    style={{
                      background: "#f7f3f3",
                      paddingTop: 10,
                      borderRadius: 6,
                    }}
                    id="divDesignColor"
                  >
                    <div className="row">
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">
                          Length:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Length"
                            id="input_length"
                          />
                        </div>
                      </div>
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">Width:</label>
                        <div className="col-sm-6 padding-remove">
                          <select
                            className="form-control"
                            id="input_width"
                          ></select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">
                          Yarn Count:
                        </label>
                        <div className="col-sm-6 padding-remove">
                          <select
                            className="form-control"
                            id="input_yarnCount"
                          ></select>
                        </div>
                      </div>
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">
                          Construction:
                        </label>
                        <div className="col-sm-6 padding-remove">
                          <select
                            className="form-control"
                            id="input_construction"
                          ></select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">
                          Design Color:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                          <input
                            type="text"
                            style={{ display: "none" }}
                            className="form-control"
                            placeholder="Design Id"
                            id="input_designId"
                          />
                          <input
                            type="text"
                            onClick={this.openDesignPopup.bind(this)}
                            className="form-control"
                            placeholder="Design Color"
                            id="input_designColor"
                          />
                        </div>
                      </div>
                      <div className="form-group col-sm-6 padding-remove">
                        <label className="control-label col-sm-6">
                          Quality Name:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                          <select
                            id="input_qualityCmb"
                            className="form-control"
                          ></select>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: 10 }}>
                      <div className="form-group col-sm-6 padding-remove"></div>
                      <div className="form-group col-sm-6 padding-remove text-right">
                        <button
                          id="maintainDesignBtn"
                          type="button"
                          onClick={this.maintainDesign.bind(this)}
                          className="btn btn-warning"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="designPopup">
          <div className="closeBtn" onClick={this.closePoPup.bind(this)}>
            <span
              style={{
                position: "absolute",
                color: "#fff",
                top: "18px",
                left: "18px",
              }}
              className="glyphicon glyphicon-remove"
            ></span>
          </div>
          <div className="container-fluid">
            <div className="col-sm-10 col-centered">
              <div className="col-sm-5 col-xs-12 padding-remove">
                <table
                  className="tableLayout2"
                  style={{ width: this.state.width1 }}
                >
                  <thead>
                    <tr>
                      <th style={{ width: 70 }}>Design Id</th>
                      <th style={{ width: 100 }}>
                        <input
                          onChange={this.setDesignColorTable}
                          type="text"
                          className="form-control inp-search"
                          id="designNoColor"
                          placeholder="Design Color"
                        />
                      </th>
                      <th style={{ width: 50 }}>Image</th>
                      <th style={{ width: 100 }}>Updated On</th>
                    </tr>
                  </thead>
                </table>
                <div className="designColorTableDiv col-sm-12 col-xs-11 padding-remove">
                  <table id="designColorTable" className="tableLayout">
                    <colgroup>
                      <col width="70" />
                      <col width="100" />
                      <col width="50" />
                      <col width="100" />
                    </colgroup>
                    <tbody id="designColorTableBody"></tbody>
                  </table>
                </div>
              </div>
              <div className="col-sm-7 col-xs-12">
                <div
                  className="col-sm-7 padding-remove"
                  style={{ height: 290, overflowY: "scroll" }}
                >
                  <table id="machineTable" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th style={{ width: 100, height: 39, display: "none" }}>
                          Machine Id
                        </th>
                        <th style={{ width: 100, height: 39 }}>Machine Type</th>
                        <th style={{ width: 100, height: 39 }}>Capacity</th>
                        <th style={{ width: 50, height: 39 }}>Select</th>
                      </tr>
                    </thead>
                    <tbody id="machineTableBody"></tbody>
                  </table>
                </div>
                <div
                  className="col-sm-5 padding-remove"
                  id="designColorImageDiv1"
                >
                  <ReactImageMagnify
                    {...{
                      smallImage: {
                        alt: "Design Image",
                        src: this.state.src,
                        isFluidWidth: true,
                      },
                      largeImage: {
                        src: this.state.src,
                        width: 600,
                        height: 900,
                      },
                      enlargedImageContainerDimensions: {
                        width: 300,
                        height: 300,
                      },
                      enlargedImageContainerStyle: {
                        left: -10,
                        top: 210,
                      },
                    }}
                  />
                </div>
              </div>
              <div className="col-sm-12 text-center">
                <button
                  type="button"
                  onClick={this.selectDesignColor}
                  className="btn btn-warning"
                >
                  Select
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MaintainBuyersPO;
